//export{}
// async function fetchJSONData(url: string): Promise<any> {  
//     const response = await fetch(url);  
//     const data = await response.json();  
//     return data;  
// } 

// async function getData(){
//     const jsonData = await fetchJSONData('./biasJS0.json');  
//     console.log(jsonData); 
// } 

// getData();

const biasJS0_36:number[] = [0.11744517087936401, -0.11800909042358398, -0.0812646895647049, -0.023968400433659554, -0.019441301003098488, -0.06524000316858292, -0.020043691620230675, 0.009888590313494205, -0.024238629266619682, 0.02590559422969818, -0.1312553435564041, -0.04281879588961601, -0.0075410217978060246, -0.026777848601341248, -0.036562491208314896, -0.054230399429798126, -0.017625559121370316, -0.09309267997741699, -0.021964965388178825, 0.09414232522249222, 0.03263591229915619, 0.05374503880739212, -0.11239535361528397, 0.013872700743377209];
const biasJS1_36:number[] = [-0.07446111738681793, -0.011310986243188381, 0.01185276173055172, -0.02512723207473755, -0.0013210921315476298, -0.046220626682043076, -0.08224610984325409, -0.08369167894124985, -0.031445201486349106, -0.056359946727752686, -0.07169030606746674, 0.006548814009875059, 0.10668740421533585, -0.06162905693054199, -0.028052913025021553, -0.06747421622276306, -0.031044429168105125, 0.05909343808889389, 0.0535019226372242, -0.042444877326488495, -0.08150254189968109, 0.0015991050750017166, -0.03311089426279068, -0.03634868934750557];
const biasJS2_36:number[] = [0.0023025714326649904, -0.02984294667840004, -0.02246096543967724, 0.005616407375782728, 0.002206171629950404, -0.0004206296871416271, -0.007303866557776928, -0.016514893621206284, 0.008565519005060196];

const weitsJS0_36:number[][] = [[0.26791244745254517, 0.08639741688966751, 0.1733982414007187, 0.2179701179265976, -0.14520643651485443, -0.04838637262582779, -0.0764743834733963, 0.12984506785869598, -0.03114345297217369, 0.0937829464673996, -0.29554611444473267, -0.05768730118870735, 0.12884339690208435, 0.14728274941444397, 0.06227476894855499, -0.01159644965082407, -0.29957374930381775, 0.00851888582110405, 0.22996686398983002, 0.023944487795233727, -0.4625000059604645, 0.3875654637813568, -0.05039479210972786, 0.16077521443367004], [-0.28158584237098694, -0.1130904108285904, -0.18855050206184387, -0.10462873429059982, 0.12729233503341675, 0.04568719491362572, 0.1688649207353592, -0.04344918578863144, -0.30947694182395935, 0.3461979925632477, 0.004301448352634907, 0.08360800892114639, 0.4034102261066437, -0.029639191925525665, 0.016389301046729088, 0.08040615171194077, 0.0916873961687088, -0.09320718050003052, -0.24530798196792603, 0.10648725926876068, 0.21958383917808533, 0.15291324257850647, 0.11156320571899414, 0.3348974883556366], [0.05648888647556305, -0.28550952672958374, -0.19050930440425873, -0.08293398469686508, 0.08833838254213333, -0.19805684685707092, -0.3568779528141022, -0.13803577423095703, 0.23592334985733032, 0.2639962434768677, -0.2500995695590973, 0.2656824290752411, 0.1903432309627533, 0.1386144757270813, 0.10708396136760712, 0.19382578134536743, -0.05609153211116791, 0.24218371510505676, -0.09183775633573532, 0.10287749767303467, -0.15494251251220703, -0.10425981879234314, 0.14338727295398712, 0.21286451816558838], [-0.11999782174825668, -0.5637616515159607, 0.19477345049381256, 0.20101948082447052, 0.3094414472579956, 0.16718719899654388, -0.04521714523434639, -0.09178301692008972, -0.397006630897522, -0.1499006599187851, -0.13214460015296936, 0.14233119785785675, 0.06920060515403748, 0.17430265247821808, -0.07999686151742935, 0.17298874258995056, -0.17771321535110474, 0.22484344244003296, 0.05467245355248451, 0.11637371778488159, 0.07928859442472458, -0.27885305881500244, -0.4215732514858246, -0.0008268236415460706], [0.24882246553897858, -0.11677441000938416, -0.09580742567777634, -0.005812986753880978, -0.29709380865097046, 0.1570909023284912, -0.08335314691066742, -0.263659805059433, -0.004056152887642384, -0.14008334279060364, 0.17910021543502808, -0.05096596106886864, -0.07352236658334732, -0.030991576611995697, 0.13084597885608673, 0.11557866632938385, 0.1671506017446518, -0.023187261074781418, 0.08178603649139404, 0.04289686679840088, -0.019545752555131912, 0.22250983119010925, 0.00918529462069273, 0.19658659398555756], [0.112007275223732, 0.18738333880901337, 0.1045277789235115, -0.14742693305015564, 0.07030592858791351, -0.17202648520469666, -0.14737951755523682, -0.05077914148569107, -0.01762697845697403, -0.01493328157812357, -0.2457195520401001, 0.06536644697189331, 0.1664568930864334, -0.0868721678853035, 0.22231440246105194, -0.14874207973480225, 0.02880246937274933, -0.2565964460372925, -0.03751995041966438, 0.34145233035087585, -0.09678155183792114, -0.02672036737203598, -0.02728218585252762, 0.05988675355911255], [0.290533185005188, -0.008727872744202614, 0.17582868039608002, -0.03160440921783447, -0.1796683669090271, 0.07092230767011642, -0.18342295289039612, -0.2964988946914673, 0.06033552810549736, 0.008005770854651928, 0.0083841597661376, -0.0018907845951616764, -0.19861648976802826, -0.03837449848651886, 0.11905385553836823, 0.15424801409244537, -0.5461997985839844, 0.0894264280796051, -0.06931965053081512, -0.14393645524978638, 0.11371182650327682, -0.07957310229539871, 0.16765852272510529, -0.08632318675518036], [0.17390303313732147, 0.07190782576799393, -0.03219818323850632, -0.14748923480510712, 0.003345207078382373, -0.057822320610284805, 0.05127929896116257, -0.006144364830106497, -0.2984752953052521, -0.010454223491251469, 0.20904739201068878, -0.11647535860538483, 0.045799124985933304, 0.13442936539649963, -0.0645444244146347, -0.09000728279352188, -0.15062281489372253, -0.2779274582862854, 0.20724619925022125, -0.30342987179756165, 0.019405711442232132, 0.1862524449825287, -0.14592482149600983, -0.20743517577648163], [-0.2137575000524521, -0.70460444688797, -0.043817028403282166, -0.2623499929904938, -0.09809840470552444, -0.22266553342342377, -0.01367135625332594, -0.02977699413895607, 0.20445334911346436, -0.021505307406187057, 0.14269740879535675, -0.10492119193077087, 0.07682938128709793, -0.0855247750878334, -0.020261535421013832, -0.1168568879365921, 0.1590445190668106, 0.16033171117305756, 0.06616023927927017, -0.001239537843503058, -0.2015080600976944, -0.013405386358499527, -0.24030090868473053, -0.17883269488811493], [-0.15820996463298798, -0.01462710089981556, -0.040331803262233734, -0.010278692469000816, 0.14394687116146088, 0.25678154826164246, 0.16226187348365784, 0.3075750768184662, 0.029012596234679222, 0.08825775235891342, -0.10850401222705841, 0.18692348897457123, 0.086746945977211, 0.02849281206727028, 0.22872036695480347, 0.24933572113513947, 0.11795172840356827, 0.14246866106987, 0.021295998245477676, -0.29515767097473145, -0.03457771614193916, -0.23808355629444122, -0.15406182408332825, -0.2603597939014435], [-0.0562593974173069, -0.029057933017611504, 0.0991506278514862, -0.17757928371429443, -0.26767492294311523, -0.013025741092860699, 0.10811762511730194, -0.2799094617366791, -0.20115263760089874, 0.1744852215051651, -0.06976542621850967, -0.17379961907863617, 0.14707911014556885, 0.1535591036081314, -0.024331314489245415, 0.12363746017217636, -0.16269360482692719, -0.320040762424469, -0.30180299282073975, -0.0992165058851242, 0.1281745284795761, -0.07293117791414261, 0.16713623702526093, -0.4244917333126068]];
const weitsJS1_36:number[][] = [[0.12918584048748016, -0.008809554390609264, -0.42471158504486084, -0.14743180572986603, -0.0731019526720047, 0.027742275968194008, -0.8128566145896912, -0.51787930727005, 0.18731212615966797, 0.07681211829185486, -0.30690568685531616, 0.29680341482162476, -0.3529823422431946, 0.006569235119968653, -0.04022323340177536, -0.2987337112426758, -0.1604233682155609, 0.014974946156144142, 0.06751386821269989, -0.02817009948194027, 0.13857677578926086, -0.009663064032793045, -0.03582088276743889, -0.13028551638126373], [0.4960242807865143, 0.10334059596061707, 0.26227006316185, 0.05361392721533775, 0.0444534569978714, -0.33703139424324036, 0.40765899419784546, 0.19765841960906982, -0.21791483461856842, -0.18431098759174347, -0.1988803595304489, -0.2128937542438507, 0.31726792454719543, -0.19148600101470947, -0.03260212764143944, 0.06761136651039124, 0.24520012736320496, 0.00591905927285552, -0.26443058252334595, 0.13033658266067505, -0.024888787418603897, -0.03152311593294144, 0.23241446912288666, -0.08524475991725922], [-0.03085528127849102, 0.16272281110286713, -0.055502548813819885, -0.16408872604370117, 0.003004213562235236, 0.09691672772169113, 0.036554187536239624, -0.1860257089138031, 0.2651585042476654, -0.0580948106944561, 0.06758589297533035, -0.10374344140291214, 0.007497972343116999, 0.18372675776481628, -0.12126540392637253, -0.03244829922914505, 0.054413601756095886, 0.028791792690753937, -0.08005162328481674, -0.112190842628479, -0.08402550965547562, -0.012117580510675907, 0.1941317468881607, -0.01779412478208542], [0.15256792306900024, 0.2822195887565613, -0.04412509873509407, 0.209497332572937, -0.26470765471458435, -0.18683530390262604, -0.35004082322120667, 0.1335919350385666, -0.09165743738412857, -0.11524895578622818, -0.13562093675136566, -0.22427217662334442, 0.3892941176891327, 0.0237636286765337, -0.07783951610326767, 0.015982018783688545, -0.1827845722436905, 0.16845907270908356, -0.17108206450939178, 0.068874791264534, 0.011999215930700302, -0.2564243674278259, 0.02028324082493782, 0.2629091739654541], [-0.19931355118751526, -0.14843085408210754, 0.19965367019176483, 0.08316085487604141, 0.27824583649635315, -0.13314221799373627, 0.21772153675556183, 0.14455418288707733, -0.007988286204636097, 0.12873446941375732, 0.17149882018566132, -0.21793068945407867, -0.11717712879180908, -0.0996599867939949, -0.11445227265357971, 0.11071564257144928, 0.1265701800584793, -0.18295884132385254, -0.05104075372219086, -0.013059952296316624, 0.03758462145924568, 0.22225326299667358, -0.1835973560810089, -0.31216031312942505], [0.1628534495830536, -0.21023058891296387, -0.0653747096657753, -0.02225520834326744, -0.08892352879047394, -0.041515786200761795, -0.28524044156074524, -0.17112794518470764, -0.09820660948753357, -0.2157852202653885, 0.1918688863515854, -0.12896232306957245, 0.1278512328863144, -0.022919459268450737, 0.2818087637424469, -0.30829358100891113, -0.30479109287261963, -0.03618607297539711, 0.04281798377633095, 0.17133741080760956, -0.0812675952911377, -0.18992047011852264, -0.07378379255533218, -0.017996056005358696], [-0.10636971890926361, 0.16862605512142181, 0.08836319297552109, -0.30278074741363525, 0.034979600459337234, -0.11842837929725647, 0.20486269891262054, 0.1141246035695076, -0.031389277428388596, -0.06187942624092102, -0.08859729766845703, -0.2162330150604248, -0.0630171075463295, -0.0940498411655426, 0.23392367362976074, 0.008783143945038319, 0.13761308789253235, 0.02980492264032364, 0.04780684411525726, 0.017057782039046288, 0.09744400531053543, 0.3138301968574524, -0.171890988945961, 0.24550771713256836], [0.08435340225696564, -0.02635793387889862, -0.020386360585689545, -0.2816951870918274, -0.10503437370061874, -0.1155102401971817, 0.15219596028327942, -0.14361612498760223, 0.38283634185791016, -0.42743781208992004, 0.26827794313430786, 0.15830835700035095, 0.2014365941286087, -0.3104085624217987, 0.07969418168067932, 0.047689039260149, 0.23644424974918365, 0.34435006976127625, 0.01007938478142023, 0.043869633227586746, -0.22334951162338257, -0.5069773197174072, 0.27421680092811584, 0.051837824285030365], [0.25779080390930176, 0.22635437548160553, -0.24247504770755768, 0.22674450278282166, 0.13825392723083496, 0.23452024161815643, 0.2510138750076294, 0.16114425659179688, -0.16790957748889923, -0.0632999837398529, 0.06810075789690018, -0.03732052817940712, 0.026367533951997757, 0.2283581644296646, 0.058634284883737564, -0.17255379259586334, 0.1466740071773529, 0.1739107072353363, 0.0434143953025341, 0.10617215931415558, -0.17992711067199707, 0.2809656858444214, -0.09273973852396011, 0.2824068069458008], [0.1869608461856842, -0.32030388712882996, -0.12930554151535034, 0.13400070369243622, -0.3270244300365448, -0.09291748702526093, 0.21904994547367096, 0.007390085607767105, -0.1984860897064209, -0.1903955489397049, -0.14413680136203766, -0.022462816908955574, 0.11710293591022491, -0.31937098503112793, 0.1500634402036667, -0.15935435891151428, 0.16682474315166473, 0.08209262788295746, -0.16415488719940186, 0.1522696167230606, -0.10319364815950394, -0.06669320166110992, -0.07924876362085342, -0.059129226952791214], [0.16731780767440796, -0.2585596442222595, -0.27535703778266907, -0.005212932825088501, -0.027539314702153206, 0.06375864148139954, 0.1178227961063385, 0.11810263246297836, -0.35949504375457764, 0.21004199981689453, 0.029353758320212364, 0.019449133425951004, -0.6560019850730896, -0.06876204162836075, 0.07766406983137131, 0.09023293107748032, 0.07618693262338638, 0.2672148644924164, -0.3411934971809387, -0.23273086547851562, 0.3823710083961487, 0.25381171703338623, -0.006617598235607147, -0.15608693659305573], [-0.10768501460552216, 0.13629096746444702, -0.11501292139291763, -0.07861143350601196, -0.14011092483997345, 0.23499290645122528, -0.14167822897434235, -0.10202309489250183, -0.01732979714870453, 0.27409693598747253, -0.1701432466506958, -0.18948529660701752, 0.2819976508617401, 0.38414305448532104, -0.10793479532003403, -0.21987396478652954, -0.193886399269104, -0.0315021350979805, 0.1500777006149292, -0.022730721160769463, -0.296798974275589, -0.1877983659505844, -0.11366824805736542, 0.18491369485855103], [-0.11185728013515472, 0.06731627136468887, -0.046150170266628265, -0.2896623909473419, -0.17000751197338104, -0.027208760380744934, -0.0927729457616806, 0.029157374054193497, 0.20088183879852295, 0.11696465313434601, 0.03985632583498955, -0.34565722942352295, -0.24711431562900543, -0.09817250072956085, -0.2076575607061386, 0.010906944051384926, -0.09940709173679352, -0.3481205999851227, -0.11358138918876648, -0.18524296581745148, -0.06707823276519775, -0.0805717334151268, 0.23517271876335144, -0.1679697483778], [0.0076554203405976295, -0.04179280251264572, -0.03146548569202423, -0.055150389671325684, 0.040157854557037354, -0.18940462172031403, 0.10725589096546173, 0.22538667917251587, 0.08805647492408752, 0.16794393956661224, -0.25215932726860046, -0.20545276999473572, -0.05034049600362778, 0.21081234514713287, -0.05286522954702377, -0.041348397731781006, 0.18395772576332092, 0.05555974692106247, 0.05101504549384117, 0.15030282735824585, -0.22705017030239105, -0.13285993039608002, 0.18708640336990356, -0.24824991822242737], [-0.16908615827560425, 0.16474279761314392, 0.15825824439525604, 0.23829731345176697, -0.2562437057495117, 0.2764773964881897, -0.07291477918624878, -0.2709197700023651, 0.035998426377773285, 0.1979243904352188, -0.19523410499095917, 0.2576679587364197, 0.08632420748472214, 0.1923796385526657, -0.15892206132411957, -0.34569671750068665, -0.1183074340224266, -0.2214830368757248, -0.22504061460494995, 0.071731336414814, -0.17004643380641937, -0.07058190554380417, 0.08170795440673828, 0.18187831342220306], [0.17256198823451996, 0.19914554059505463, 0.16273391246795654, -0.19979941844940186, -0.208224356174469, -0.1974746733903885, -0.054597433656454086, -0.17065730690956116, -0.18751296401023865, -0.26722216606140137, 0.06949469447135925, 0.11823874711990356, -0.1936827152967453, -0.11773690581321716, 0.07745099812746048, 0.044219207018613815, -0.02556077018380165, -0.26902085542678833, 0.10878787189722061, 0.006609747651964426, 0.18636663258075714, 0.018339380621910095, -0.27756839990615845, 0.04863028973340988], [0.047239143401384354, -0.06243477761745453, -0.2515452802181244, -0.26067546010017395, -0.10655458271503448, -0.0872170478105545, 0.07521048188209534, 0.046620603650808334, -0.6602354049682617, 0.13991206884384155, -0.1137324795126915, -0.009831038303673267, 0.13910634815692902, -0.3171338737010956, -0.12686707079410553, -0.09109890460968018, 0.20651870965957642, -0.2981283366680145, 0.1184239313006401, 0.03770957142114639, -0.15924522280693054, -0.3571620583534241, -0.16925260424613953, -0.017025018110871315], [0.2874392867088318, 0.14743918180465698, -0.05402439832687378, -0.2986970543861389, 0.042859550565481186, 0.19101358950138092, 0.08360635489225388, 0.2630603015422821, 0.2731316387653351, -0.248921200633049, 0.04039660841226578, -0.3853645622730255, -0.023790866136550903, -0.06353995203971863, 0.22287888824939728, -0.10737793892621994, 0.1126064881682396, -0.09791386127471924, 0.042425092309713364, 0.14020965993404388, 0.00048414201592095196, 0.0774594247341156, 0.19483329355716705, 0.050114911049604416], [-0.14120891690254211, 0.133466899394989, -0.19302061200141907, -0.2012907862663269, 0.2500654458999634, -0.32262083888053894, 0.23461389541625977, -0.2191380262374878, 0.09865158051252365, -0.08882884681224823, -0.0483788326382637, -0.3184201717376709, 0.07912009209394455, 0.18594834208488464, -0.14640559256076813, 0.12943176925182343, 0.06012891232967377, -0.05222254619002342, -0.562127411365509, 0.12093055248260498, -0.5193123817443848, -0.023027701303362846, 0.027009859681129456, -0.0976739227771759], [-0.04125627130270004, -0.05992446467280388, -0.13264600932598114, -0.10527953505516052, 0.1855526715517044, 0.03782487288117409, 0.1846379041671753, -0.4402732253074646, -0.12059423327445984, -0.48958539962768555, 0.18744269013404846, -0.7505680322647095, -0.41463813185691833, -0.19398629665374756, -0.10471823811531067, 0.13883250951766968, -0.5861955285072327, -0.26382410526275635, 0.5120058655738831, 0.12648791074752808, 0.09864208102226257, 0.08576368540525436, -0.24559172987937927, 0.1587219536304474], [-0.05280303582549095, 0.014094272628426552, -0.019598521292209625, 0.09795841574668884, 0.11569355428218842, 0.06355921179056168, -0.0027752958703786135, 0.14436668157577515, 0.12654398381710052, 0.2851894795894623, 0.03630092740058899, -0.6852852702140808, -0.3273760676383972, 0.041877295821905136, -0.16065417230129242, 0.13278916478157043, -0.3274657726287842, 0.2220095992088318, 0.05636826530098915, -0.12142207473516464, 0.24595554172992706, -0.027727017179131508, 0.11713970452547073, -0.21133238077163696], [-0.4516837000846863, 0.15515415370464325, -0.08324464410543442, -0.12271693348884583, -0.04543354734778404, 0.5141000747680664, -0.3058665096759796, -0.24940995872020721, 0.11946515738964081, 0.06508326530456543, 0.37552645802497864, -0.7472231388092041, 0.2311868816614151, -0.029193881899118423, 0.04881453886628151, 0.12404788285493851, -0.15798600018024445, -0.014306419529020786, -0.12889836728572845, 0.023431861773133278, 0.28864145278930664, -0.270101398229599, -0.06691768765449524, 0.41108569502830505], [-0.15545888245105743, 0.000596869271248579, -0.3074593245983124, 0.11836640536785126, -0.20070821046829224, 0.08267510682344437, -0.5515791177749634, -0.12213460355997086, -0.07982894033193588, -0.3149261474609375, 0.1590387523174286, -0.6366682052612305, -0.05142462998628616, 0.2449423223733902, 0.07776384800672531, 0.031698450446128845, -0.036950498819351196, 0.2076680213212967, -0.09365496039390564, -0.022748932242393494, -0.2866767346858978, -0.005786570720374584, -0.06767510622739792, 0.04306793212890625], [-0.6012465357780457, 0.23305681347846985, -0.21482375264167786, 0.26092082262039185, 0.08459523320198059, -0.07295981049537659, -0.15860378742218018, -0.16513103246688843, 0.3482562005519867, 0.1985584795475006, -0.19587060809135437, -0.8050441741943359, 0.23141521215438843, -0.1342625617980957, 0.24541287124156952, 0.24074548482894897, 0.1326749473810196, -0.057035814970731735, -0.03248145058751106, -0.03301486000418663, -0.27454203367233276, -0.18373632431030273, -0.25223368406295776, -0.18953421711921692]];
const weitsJS2_36:number[][] = [[0.23542216420173645, 0.00040486929356120527, -0.027509639039635658, -0.027742749080061913, 0.2785490155220032, 0.12575246393680573, -0.08308649808168411, -0.06216984987258911, -0.04520972818136215], [-0.07319376617670059, 0.10750305652618408, 0.1487642079591751, -0.08839080482721329, -0.3466838300228119, 0.018661225214600563, -0.15474805235862732, 0.22996248304843903, -0.30679991841316223], [0.10677384585142136, -0.14625051617622375, -0.0024585039354860783, -0.294172078371048, 0.3975847065448761, -0.35214847326278687, -0.0051306746900081635, -0.2410130798816681, 0.017883699387311935], [-0.21202728152275085, 0.031278304755687714, -0.2884882986545563, -0.28405433893203735, -0.34278467297554016, 0.030910789966583252, 0.21083836257457733, -0.15003222227096558, -0.22952048480510712], [0.3624569773674011, 0.29975128173828125, -0.01325063407421112, 0.1018417626619339, -0.12244999408721924, -0.215168297290802, 0.00796897616237402, 0.3359423577785492, 0.3003308176994324], [0.01622827723622322, 0.08745259791612625, -0.1361280083656311, 0.015574296936392784, 0.3293197751045227, -0.019686656072735786, 0.11207449436187744, -0.03789723291993141, 0.35945311188697815], [0.17532820999622345, -0.2617104947566986, 0.1911078542470932, -0.023514512926340103, 0.10004023462533951, -0.24011532962322235, -0.0007400617469102144, -0.09741846472024918, -0.4338853061199188], [-0.05413684621453285, 0.11142882704734802, -0.14462582767009735, 0.058972787111997604, 0.02915830723941326, 0.17115123569965363, 0.08647701889276505, 0.23587188124656677, 0.36600351333618164], [-0.38705068826675415, -0.06973619014024734, 0.18511883914470673, -0.10354495793581009, 0.14823803305625916, 0.24589943885803223, 0.02212650701403618, -0.14625859260559082, -0.014047399163246155], [0.09008831530809402, -0.25188738107681274, -0.05050285533070564, -0.07510672509670258, -0.16402225196361542, -0.05461934581398964, 0.07857045531272888, -0.572820246219635, 0.038307055830955505], [0.5029556155204773, 0.03971521556377411, -0.11288686841726303, 0.31979650259017944, 0.14706365764141083, 0.22143995761871338, -0.329476535320282, 0.30521756410598755, 0.1203152984380722], [0.06764040887355804, 0.043785180896520615, 0.0655408576130867, -0.10374367237091064, 0.16071991622447968, -0.09447164833545685, -0.8334988951683044, -0.05133107677102089, 0.05501970276236534], [0.6114596128463745, -0.016375329345464706, -0.14576582610607147, -0.03261445090174675, 0.2887279689311981, 0.14301013946533203, 0.12394623458385468, 0.10784342139959335, 0.34146687388420105], [0.20797769725322723, 0.03888672590255737, -0.10813707858324051, 0.20389537513256073, 0.17743468284606934, -0.2794249355792999, 0.028888465836644173, -0.16080787777900696, 0.22729769349098206], [-0.08248075097799301, -0.13618318736553192, 0.4246519207954407, 0.0923837274312973, -0.24520118534564972, 0.08276919275522232, -0.18206125497817993, 0.08063064515590668, -0.0914144366979599], [0.19057540595531464, -0.39374077320098877, -0.029394647106528282, 0.4077399671077728, -0.304966539144516, 0.1083388701081276, 0.1107061430811882, 0.24674732983112335, -0.33437228202819824], [-0.2774924039840698, 0.34196996688842773, -0.0921921506524086, -0.01674739271402359, -0.09449318051338196, 0.3283707797527313, 0.06184913218021393, 0.030163247138261795, -0.3106023669242859], [-0.023266848176717758, 0.46536365151405334, 0.4489598572254181, 0.016187695786356926, 0.003044349141418934, 0.17472566664218903, 0.07470259815454483, 0.2089112401008606, -0.14039479196071625], [0.1764686405658722, 0.21033722162246704, -0.022141024470329285, -0.41425254940986633, -0.04152214527130127, 0.07668928056955338, 0.3706851601600647, 0.05179494246840477, 0.2773291766643524], [-0.27854660153388977, -0.06507527828216553, -0.3981513977050781, -0.03427017480134964, -0.16794556379318237, -0.11251915246248245, 0.1674998253583908, -0.18895520269870758, 0.260469526052475], [0.0615420937538147, 0.2128753662109375, -0.013943935744464397, -0.1460317224264145, -0.5161508321762085, 0.017121950164437294, 0.037957996129989624, -0.07761445641517639, -0.03935172036290169], [0.04713389649987221, 0.2872962951660156, 0.16385535895824432, 0.003124081762507558, -0.066952183842659, 0.05764104053378105, -0.5991421341896057, -0.20429378747940063, 0.6831538081169128], [0.16127178072929382, 0.09694596379995346, -0.19888834655284882, 0.1620059311389923, 0.09496106207370758, -0.3882259726524353, 0.01741694286465645, 0.05554386228322983, 0.15033899247646332], [-0.03971780464053154, -0.10654452443122864, 0.1605110466480255, 0.18189102411270142, -0.09245526790618896, -0.1447095274925232, -0.0005912490305490792, 0.012689854018390179, -0.3065742552280426]];

const weitsJS0:number[][] = weitsJS0_36;
const weitsJS1:number[][] = weitsJS1_36;
const weitsJS2:number[][] = weitsJS2_36;

const biasJS0:number[] = biasJS0_36;
const biasJS1:number[] = biasJS1_36;
const biasJS2:number[] = biasJS2_36;


let nameToInt = {
    "c0" :0 ,
    "c1" :1 ,
    "c2" :2 ,
    "c3" :3 ,
    "c4" :4 ,
    "c5" :5 ,
    "c6" :6 ,
    "c7" :7 ,
    "c8" :8 ,
}

const cardSet = []
let cardSetDiv: HTMLDivElement
const gameField = [0,0,0,0,0,0,0,0,0]
const fieldView: HTMLElement[] = []


//let numUsedCards = 0

// квадратное поле 3x3
function addCardSq(ind:number){
    let nRow = ind/3|0
    let nCol = ind%3
    let isLine = false
        
    if (nRow == 0) {
        isLine = false

        if (nCol == 0) {
            // проверяем по вертикали
            if (gameField[3] != 0 &&
                gameField[6] != 0 &&
                (gameField[0]) ==
                (gameField[3]) &&
                (gameField[0]) ==
                (gameField[6])) {
                gameField[3] = 0;
                fieldView[3].innerHTML = '' + 0 
                gameField[6] = 0;
                fieldView[6].innerHTML = '' + 0 
                isLine = true
            }

            // проверяем по горизонтали
            if (gameField[1] != 0 &&
                gameField[2] != 0 &&
                (gameField[0]) ==
                (gameField[1]) &&
                (gameField[0]) ==
                (gameField[2])) {
                gameField[1] = 0
                fieldView[1].innerHTML = '' + 0 
                gameField[2] = 0
                fieldView[2].innerHTML = '' + 0 
                isLine = true
            }

            // проверяем по диагонали
            if (gameField[4] != 0 &&
                gameField[8] != 0 &&
                (gameField[0]) ==
                (gameField[4]) &&
                (gameField[0]) ==
                (gameField[8])) {
                gameField[4] = 0
                fieldView[4].innerHTML = '' + 0 
                gameField[8] = 0
                fieldView[8].innerHTML = '' + 0 
                isLine = true
            }

            if (isLine){
                gameField[0] = 0
                fieldView[0].innerHTML = '' + 0 
            }
        }
        if (nCol == 1) {
            // проверяем по вертикали
            if (gameField[4] != 0 &&
                gameField[7] != 0 &&
            (gameField[1]) ==
                (gameField[4]) &&
                (gameField[1]) ==
                (gameField[7])) {
                gameField[4] = 0
                fieldView[4].innerHTML = '' + 0 
                gameField[7] = 0
                fieldView[7].innerHTML = '' + 0 
                isLine = true
            }

            // проверяем по горизонтали
            if (gameField[0] != 0 &&
                gameField[2] != 0 &&
                (gameField[0]) ==
                (gameField[1]) &&
                (gameField[1]) ==
                (gameField[2])) {
                gameField[0] = 0
                fieldView[0].innerHTML = '' + 0 
                gameField[2] = 0
                fieldView[2].innerHTML = '' + 0 
                isLine = true
            }

            if (isLine){
                gameField[1] = 0
                fieldView[1].innerHTML = '' + 0 
            }
        }
        if (nCol == 2) {
            // проверяем по вертикали
            if (gameField[5] != 0 &&
                gameField[8] != 0 &&
                (gameField[2]) ==
                (gameField[5]) &&
                (gameField[2]) ==
                (gameField[8])) {
                gameField[5] = 0
                fieldView[5].innerHTML = '' + 0 
                gameField[8] = 0
                fieldView[8].innerHTML = '' + 0 
                isLine = true
            }

            // проверяем по горизонтали
            if (gameField[0] != 0 &&
                gameField[1] != 0 &&
                (gameField[0]) ==
                (gameField[2]) &&
                (gameField[1]) ==
                (gameField[2])) {
                gameField[0] = 0
                fieldView[0].innerHTML = '' + 0 
                gameField[1] = 0
                fieldView[1].innerHTML = '' + 0 
                isLine = true
            }

            // проверяем по диагонали
            if (gameField[4] != 0 &&
                gameField[6] != 0 &&
                (gameField[4]) ==
                (gameField[2]) &&
                (gameField[6]) ==
                (gameField[2])) {
                gameField[4] = 0
                fieldView[4].innerHTML = '' + 0 
                gameField[6] = 0
                fieldView[6].innerHTML = '' + 0 
                isLine = true
            }

            if (isLine){
                gameField[2] = 0
                fieldView[2].innerHTML = '' + 0 
            }
        }
    }
    if (nRow == 1) {
        isLine = false

        if (nCol == 0) {
            // проверяем по вертикали
            if (gameField[0] != 0 &&
                gameField[6] != 0 &&
                (gameField[0]) ==
                (gameField[3]) &&
                (gameField[6]) ==
                (gameField[3])) {
                gameField[0] = 0
                fieldView[0].innerHTML = '' + 0 
                gameField[6] = 0
                fieldView[6].innerHTML = '' + 0 
                isLine = true
            }

            // проверяем по горизонтали
            if (gameField[4] != 0 &&
                gameField[5] != 0 &&
                (gameField[4]) ==
                (gameField[3]) &&
                (gameField[5]) ==
                (gameField[3])) {
                gameField[4] = 0
                fieldView[4].innerHTML = '' + 0 
                gameField[5] = 0
                fieldView[5].innerHTML = '' + 0 
                isLine = true
            }

            if (isLine){
                gameField[3] = 0
                fieldView[3].innerHTML = '' + 0 
            }
        }
        if (nCol == 1) {
            // проверяем по вертикали
            if (gameField[1] != 0 &&
                gameField[7] != 0 &&
                (gameField[1]) ==
                (gameField[4]) &&
                (gameField[7]) ==
                (gameField[4])) {
                gameField[1] = 0
                fieldView[1].innerHTML = '' + 0 
                gameField[7] = 0
                fieldView[7].innerHTML = '' + 0 
                isLine = true
            }

            // проверяем по горизонтали
            if (gameField[3] != 0 &&
                gameField[5] != 0 &&
                (gameField[3]) ==
                (gameField[4]) &&
                (gameField[5]) ==
                (gameField[4])) {
                gameField[3] = 0
                fieldView[3].innerHTML = '' + 0 
                gameField[5] = 0
                fieldView[5].innerHTML = '' + 0 
                isLine = true
            }

            // проверяем по диагоналям
            if (gameField[0] != 0 &&
                gameField[8] != 0 &&
                (gameField[0]) ==
                (gameField[4]) &&
                (gameField[8]) ==
                (gameField[4])) {
                gameField[0] = 0
                fieldView[0].innerHTML = '' + 0 
                gameField[8] = 0
                fieldView[8].innerHTML = '' + 0 
                isLine = true
            }

            if (gameField[2] != 0 &&
                gameField[6] != 0 &&
                (gameField[2]) ==
                (gameField[4]) &&
                (gameField[6]) ==
                (gameField[4])) {
                gameField[2] = 0
                fieldView[2].innerHTML = '' + 0 
                gameField[6] = 0
                fieldView[6].innerHTML = '' + 0 
                isLine = true
            }

            if (isLine){
                gameField[4] = 0
                fieldView[4].innerHTML = '' + 0 
            }
        }
        if (nCol == 2) {
            // проверяем по вертикали
            if (gameField[2] != 0 &&
                gameField[8] != 0 &&
                (gameField[2]) ==
                (gameField[5]) &&
                (gameField[8]) ==
                (gameField[5])) {
                gameField[2] = 0
                fieldView[2].innerHTML = '' + 0 
                gameField[8] = 0
                fieldView[8].innerHTML = '' + 0 
                isLine = true
            }

            // проверяем по горизонтали
            if (gameField[3] != 0 &&
                gameField[4] != 0 &&
                (gameField[3]) ==
                (gameField[5]) &&
                (gameField[5]) ==
                (gameField[4])) {
                gameField[3] = 0
                fieldView[3].innerHTML = '' + 0 
                gameField[4] = 0
                fieldView[4].innerHTML = '' + 0 
                isLine = true
            }

            if (isLine){
                gameField[5] = 0
                fieldView[5].innerHTML = '' + 0 
            }
        }
    }   
    if (nRow == 2) {
        isLine = false

        if (nCol == 0) {
            // проверяем по вертикали
            if (gameField[0] != 0 &&
                gameField[3] != 0 &&
                (gameField[0]) ==
                (gameField[6]) &&
                (gameField[6]) ==
                (gameField[3])) {
                gameField[0] = 0
                fieldView[0].innerHTML = '' + 0 
                gameField[3] = 0
                fieldView[3].innerHTML = '' + 0 
                isLine = true
            }

            // проверяем по горизонтали
            if (gameField[7] != 0 &&
                gameField[8] != 0 &&
                (gameField[6]) ==
                (gameField[7]) &&
                (gameField[6]) ==
                (gameField[8])) {
                gameField[7] = 0
                fieldView[7].innerHTML = '' + 0 
                gameField[8] = 0
                fieldView[8].innerHTML = '' + 0 
                isLine = true
            }

            // проверяем по диагонали
            if (gameField[4] != 0 &&
                gameField[2] != 0 &&
                (gameField[6]) ==
                (gameField[4]) &&
                (gameField[6]) ==
                (gameField[2])) {
                gameField[4] = 0
                fieldView[4].innerHTML = '' + 0 
                gameField[2] = 0
                fieldView[2].innerHTML = '' + 0 
                isLine = true
            }

            if (isLine){
                gameField[6] = 0
                fieldView[6].innerHTML = '' + 0 
            }
        }
        if (nCol == 1) {
            // проверяем по вертикали   
            if (gameField[1] != 0 &&
                gameField[4] != 0 &&
                (gameField[1]) ==
                (gameField[7]) &&
                (gameField[7]) ==
                (gameField[4])) {
                gameField[1] = 0
                fieldView[1].innerHTML = '' + 0 
                gameField[4] = 0
                fieldView[4].innerHTML = '' + 0 
                isLine = true
            }

            // проверяем по горизонтали   
            if (gameField[6] != 0 &&
                gameField[8] != 0 &&
                (gameField[6]) ==
                (gameField[7]) &&
                (gameField[7]) ==
                (gameField[8])) {
                gameField[6] = 0
                fieldView[6].innerHTML = '' + 0 
                gameField[8] = 0
                fieldView[8].innerHTML = '' + 0 
            }

            if (isLine){
                gameField[7] = 0
                fieldView[7].innerHTML = '' + 0 
            }
        }

        if (nCol == 2) {
            // проверяем по вертикали  
            if (gameField[2] != 0 &&
                gameField[5] != 0 &&
                (gameField[2]) ==
                (gameField[8]) &&
                (gameField[8]) ==
                (gameField[5])) {
                gameField[2] = 0
                fieldView[2].innerHTML = '' + 0 
                gameField[5] = 0
                fieldView[5].innerHTML = '' + 0 
                isLine = true
            }

            // проверяем по горизонтали  
            if (gameField[6] != 0 &&
                gameField[7] != 0 &&
                (gameField[6]) ==
                (gameField[8]) &&
                (gameField[8]) ==
                (gameField[7])) {
                gameField[6] = 0
                fieldView[6].innerHTML = '' + 0 
                gameField[7] = 0
                fieldView[7].innerHTML = '' + 0 
                isLine = true
            }

            // проверяем по диагонали  
            if (gameField[0] != 0 &&
                gameField[4] != 0 &&
                (gameField[0]) ==
                (gameField[8]) &&
                (gameField[8]) ==
                (gameField[4])) {
                gameField[0] = 0
                fieldView[0].innerHTML = '' + 0 
                gameField[4] = 0
                fieldView[4].innerHTML = '' + 0 
                isLine = true
            }

            if (isLine){
                gameField[8] = 0
                fieldView[8].innerHTML = '' + 0 
            }
        }

        if (isLine) {
            //self.action_space = 1
        }
    }
}

function handleClickSq(ev: MouseEvent) {
    let src:HTMLTableCellElement
    if ((ev.target as HTMLElement).tagName == "TD") {
        let key = (ev.target as HTMLTableCellElement).id
        src = ev.target as HTMLTableCellElement
        let card = cardSet.shift()
        cardSetDiv.innerHTML =cardSet.toString()
        src.innerHTML = card
        gameField[nameToInt[key]] = card
        fieldView[nameToInt[key]].innerHTML = '' + card
        addCardSq(nameToInt[key])
        let step = this.predict();
        src.innerHTML = src.innerHTML +'('+step+')';
    }
    //console.log(ev.target.id)
}

function fillCardSetSq(){
    let str = ""
    for(let i=0; i<9; i++){
        cardSet.push(1)
        cardSet.push(2)
        cardSet.push(3)
        cardSet.push(4)
    }
    cardSetDiv  = document.getElementById("cardSet") as HTMLDivElement
    cardSetDiv.innerHTML = cardSet.toString()

    gameField.forEach( (val, ind) =>{
        let el = (document.getElementById("c"+ind) as HTMLElement)
        fieldView.push(el)
        el.innerHTML = '' + 0
    })
}

class CrestField{
    cardSet:number[]
    shufledCardSet:number[]
    cardSetDiv: HTMLDivElement
    gameField:number[] 
    fieldView: HTMLElement[]
    observ: number[]
    btnEl:HTMLElement
    counter:number
    numUsedCards

    nameToInt = {
        "c0" :0 ,
        "c1" :1 ,
        "c2" :2 ,
        "c3" :3 ,
        "c4" :4 ,
        "c5" :5 ,
        "c6" :6 ,
        "c7" :7 ,
        "c8" :8 ,
        "c9" :9 ,
        "c10" :10 ,
        "c11" :11 ,
        "c12" :12 ,
    }
    // bias0: number[]
    // bias1: number[]
    // bias2: number[]
    // weight0: number[][]
    // weight1: number[][]
    // weight2: number[][]

    constructor(doc:HTMLDocument){
        const body:HTMLCollection = doc.getElementsByTagName("body")
        this.numUsedCards = 0

        // this.bias0 = [
        //     -1.8876183032989502,
        //     6.374699592590332,
        //     -2.5466785430908203,
        //     1.3777958154678345,
        //     7.231475353240967,
        //     -2.348193645477295,
        //     6.425029754638672,
        //     5.493327617645264,
        //     4.798320293426514,
        //     3.808184862136841,
        //     6.004950046539307,
        //     4.979145050048828,
        //     -1.5610947608947754,
        //     4.85793399810791,
        //     6.049415588378906,
        //     -2.6042959690093994,
        //     -1.9762921333312988,
        //     3.324725389480591,
        //     2.1117634773254395,
        //     -2.3571741580963135,
        //     0.632917046546936,
        //     5.553223133087158,
        //     3.863335132598877,
        //     2.7057547569274902
        // ];
        // this.weight0 =[
        //     [
        //         1.3696094751358032,
        //         -0.07359838485717773,
        //         -0.09921309351921082,
        //         0.18319395184516907,
        //         0.14132151007652283,
        //         0.5301502346992493,
        //         -0.0819331631064415,
        //         -3.569394826889038,
        //         -0.02796083688735962,
        //         -0.1774909496307373,
        //         -0.15207116305828094,
        //         0.030718564987182617,
        //         -0.01001095212996006,
        //         -0.1908252239227295,
        //         -0.23479856550693512,
        //         0.5857442617416382,
        //         1.0813802480697632,
        //         -0.1974903643131256,
        //         0.2849109172821045,
        //         -1.6279798746109009,
        //         1.5406628847122192,
        //         -0.022876517847180367,
        //         -10.364359855651855,
        //         1.2523927688598633
        //     ],
        //     [
        //         1.3789832592010498,
        //         -8.527722358703613,
        //         1.152313470840454,
        //         0.452440083026886,
        //         0.11718282103538513,
        //         0.7991771697998047,
        //         -0.05951335281133652,
        //         -0.07699711620807648,
        //         -0.17663834989070892,
        //         0.08331804722547531,
        //         -0.15681850910186768,
        //         -0.1676863431930542,
        //         -0.502187967300415,
        //         0.04252010956406593,
        //         -0.0849909633398056,
        //         0.6616184711456299,
        //         0.28214865922927856,
        //         0.05211364105343819,
        //         0.20415425300598145,
        //         0.7700093388557434,
        //         1.9723950624465942,
        //         -0.12464689463376999,
        //         0.06003753840923309,
        //         -1.1623634099960327
        //     ],
        //     [
        //         0.2537570595741272,
        //         -0.10215749591588974,
        //         0.040431275963783264,
        //         0.03155476972460747,
        //         0.027103165164589882,
        //         0.37352097034454346,
        //         -0.11435843259096146,
        //         0.19630534946918488,
        //         -0.044866278767585754,
        //         -0.14545594155788422,
        //         -0.15013177692890167,
        //         0.2135411500930786,
        //         0.3768550455570221,
        //         -0.4646220803260803,
        //         -0.1344188004732132,
        //         0.9209727048873901,
        //         0.8044061064720154,
        //         -6.327327728271484,
        //         0.5275176763534546,
        //         0.8194286823272705,
        //         0.36879706382751465,
        //         -10.003642082214355,
        //         -0.10504879802465439,
        //         0.3286918103694916
        //     ],
        //     [
        //         -0.39051553606987,
        //         -0.11710388958454132,
        //         0.4303794503211975,
        //         0.8023504018783569,
        //         -0.013316864147782326,
        //         0.4399143159389496,
        //         -0.11811403185129166,
        //         0.20276710391044617,
        //         -0.4803994297981262,
        //         0.4740790128707886,
        //         -6.534787178039551,
        //         -0.12082435935735703,
        //         0.08868005871772766,
        //         -0.056319933384656906,
        //         -0.25063806772232056,
        //         0.9675076007843018,
        //         -0.12375082820653915,
        //         0.86045241355896,
        //         -0.10293815284967422,
        //         1.3020009994506836,
        //         0.5689107179641724,
        //         -0.75238436460495,
        //         -0.45310965180397034,
        //         -0.011035628616809845
        //     ],
        //     [
        //         0.24613265693187714,
        //         -0.04076755791902542,
        //         1.5536775588989258,
        //         3.5746536254882812,
        //         0.03602611646056175,
        //         0.9254441857337952,
        //         -0.0469084270298481,
        //         0.16096435487270355,
        //         0.06483492255210876,
        //         -0.16002684831619263,
        //         -0.08755210787057877,
        //         0.03184511885046959,
        //         0.4527481496334076,
        //         -0.16493766009807587,
        //         -10.858072280883789,
        //         -0.821618378162384,
        //         0.7585617899894714,
        //         -0.5106766223907471,
        //         0.06864343583583832,
        //         0.7410348653793335,
        //         1.2198472023010254,
        //         0.20073965191841125,
        //         -0.14772450923919678,
        //         -0.2561306059360504
        //     ],
        //     [
        //         0.30025362968444824,
        //         -0.10373840481042862,
        //         0.2623594105243683,
        //         1.5273228883743286,
        //         0.12371040135622025,
        //         0.6276564002037048,
        //         -0.09851093590259552,
        //         0.02600094862282276,
        //         -0.18113145232200623,
        //         0.06524306535720825,
        //         -0.14326545596122742,
        //         -4.623420715332031,
        //         0.3391391932964325,
        //         -6.048059463500977,
        //         -0.19630560278892517,
        //         0.3487193286418915,
        //         0.7955556511878967,
        //         0.022290367633104324,
        //         0.3051983118057251,
        //         0.3594247102737427,
        //         0.7958428263664246,
        //         -0.11982748657464981,
        //         -0.05950997397303581,
        //         0.06777437776327133
        //     ],
        //     [
        //         0.7801909446716309,
        //         -0.09248664230108261,
        //         0.09940357506275177,
        //         -1.0153595209121704,
        //         0.08435899764299393,
        //         0.17075017094612122,
        //         -0.058232225477695465,
        //         0.1554674506187439,
        //         -6.049262523651123,
        //         -6.28169584274292,
        //         -0.11218459159135818,
        //         -0.01949341781437397,
        //         0.1391284167766571,
        //         -0.1721983700990677,
        //         -0.10752292722463608,
        //         1.3590989112854004,
        //         0.5789307355880737,
        //         0.2001228630542755,
        //         0.6304722428321838,
        //         0.8294196128845215,
        //         0.5981000065803528,
        //         -0.24533680081367493,
        //         -0.08334507793188095,
        //         0.33822911977767944
        //     ],
        //     [
        //         0.4243112802505493,
        //         -0.07566609978675842,
        //         0.2720528841018677,
        //         0.6740658283233643,
        //         0.04756448045372963,
        //         0.4649219512939453,
        //         -8.185419082641602,
        //         0.4850037395954132,
        //         -0.09221773594617844,
        //         -0.021940255537629128,
        //         -0.22591866552829742,
        //         -0.09438097476959229,
        //         0.5180769562721252,
        //         -0.07459632307291031,
        //         -0.1528426855802536,
        //         1.1873703002929688,
        //         0.7831243276596069,
        //         0.0468844510614872,
        //         1.0320607423782349,
        //         0.9944241642951965,
        //         0.35019612312316895,
        //         -0.1469622105360031,
        //         -0.14216791093349457,
        //         0.5074479579925537
        //     ],
        //     [
        //         3.8782236576080322,
        //         -0.18718546628952026,
        //         0.7165839076042175,
        //         -1.7290457487106323,
        //         -0.06189868226647377,
        //         3.872406482696533,
        //         -0.14245907962322235,
        //         0.49688032269477844,
        //         -0.06976006180047989,
        //         -0.13838450610637665,
        //         -0.20591560006141663,
        //         -0.5521157383918762,
        //         1.0798450708389282,
        //         0.44237199425697327,
        //         -0.14923107624053955,
        //         0.1432567983865738,
        //         0.5238678455352783,
        //         -0.42558786273002625,
        //         -2.301241159439087,
        //         1.5331969261169434,
        //         -4.5111165046691895,
        //         0.08682422339916229,
        //         -0.021471181884407997,
        //         0.31467169523239136
        //     ],
        //     [
        //         1.4709402322769165,
        //         -0.3110193908214569,
        //         3.198990821838379,
        //         3.765214204788208,
        //         -4.054223537445068,
        //         1.7444709539413452,
        //         -0.26419270038604736,
        //         -3.4829273223876953,
        //         -0.20377063751220703,
        //         -0.10610915720462799,
        //         -0.06005364656448364,
        //         -0.015929680317640305,
        //         1.4432852268218994,
        //         -0.42064088582992554,
        //         -0.008017046377062798,
        //         2.5457746982574463,
        //         3.27333664894104,
        //         -0.0559917613863945,
        //         2.164216995239258,
        //         2.58890962600708,
        //         2.826447010040283,
        //         -0.24300117790699005,
        //         0.45977354049682617,
        //         -0.28474992513656616
        //     ],
        //     [
        //         0.04838697612285614,
        //         -0.045141566544771194,
        //         -0.17020156979560852,
        //         0.6914470195770264,
        //         0.13812218606472015,
        //         0.2917346656322479,
        //         -0.11371230334043503,
        //         0.3606966435909271,
        //         0.040266696363687515,
        //         -0.28789985179901123,
        //         0.011608145199716091,
        //         -0.38051965832710266,
        //         0.05977807939052582,
        //         0.39741426706314087,
        //         -0.019623063504695892,
        //         -0.2557132840156555,
        //         1.2935289144515991,
        //         -0.10882838070392609,
        //         -0.15287373960018158,
        //         -0.41121965646743774,
        //         0.6207700967788696,
        //         0.0022345196921378374,
        //         0.3440141975879669,
        //         -0.09529685974121094
        //     ]
        // ];

        // this.bias1 = [
        //     0.25219589471817017,
        //     2.199065923690796,
        //     0.5163305997848511,
        //     1.7737793922424316,
        //     1.7355109453201294,
        //     2.941150665283203,
        //     -1.904043197631836,
        //     1.3057925701141357,
        //     2.581031322479248,
        //     3.102435827255249,
        //     0.016762498766183853,
        //     -0.710008442401886,
        //     0.1434781402349472,
        //     2.637162685394287,
        //     1.569477915763855,
        //     0.7468231916427612,
        //     1.7106614112854004,
        //     2.1410746574401855,
        //     -1.6933093070983887,
        //     1.7756812572479248,
        //     -1.6204744577407837,
        //     -0.7371547222137451,
        //     2.9160404205322266,
        //     0.9460389614105225
        // ]
        // this.weight1 = [
        //     [
        //         0.27257591485977173,
        //         0.3869185745716095,
        //         0.8504434823989868,
        //         0.19986295700073242,
        //         2.1833624839782715,
        //         -2.6583521366119385,
        //         0.6577317118644714,
        //         0.9097495079040527,
        //         0.406642347574234,
        //         0.16003330051898956,
        //         0.9642981290817261,
        //         -0.19441643357276917,
        //         -0.18689903616905212,
        //         -0.5865878462791443,
        //         -0.2617162764072418,
        //         -0.20887833833694458,
        //         1.284202218055725,
        //         -0.3069278597831726,
        //         1.2351911067962646,
        //         -1.7140767574310303,
        //         -0.32893723249435425,
        //         1.1261017322540283,
        //         1.743562936782837,
        //         0.9930200576782227
        //     ],
        //     [
        //         -1.6525824069976807,
        //         1.2020946741104126,
        //         -6.121692657470703,
        //         2.8772192001342773,
        //         0.4645692706108093,
        //         -0.2366919219493866,
        //         -3.779074192047119,
        //         0.9434119462966919,
        //         -5.990158557891846,
        //         1.4997889995574951,
        //         -2.4981682300567627,
        //         -4.219113349914551,
        //         -6.6248459815979,
        //         2.3648576736450195,
        //         0.5727714896202087,
        //         1.6934337615966797,
        //         0.15005964040756226,
        //         0.6258471608161926,
        //         -3.500897169113159,
        //         0.19448702037334442,
        //         -1.5161558389663696,
        //         4.475485801696777,
        //         0.5340183973312378,
        //         3.2061800956726074
        //     ],
        //     [
        //         0.6907560229301453,
        //         -0.978337824344635,
        //         0.5097180604934692,
        //         0.7867669463157654,
        //         -0.7426729202270508,
        //         -0.4525175392627716,
        //         1.2939410209655762,
        //         -0.6715952157974243,
        //         1.1685162782669067,
        //         0.015682462602853775,
        //         1.8083608150482178,
        //         1.4117552042007446,
        //         -0.3204834759235382,
        //         1.3994818925857544,
        //         -0.281608909368515,
        //         1.6220496892929077,
        //         -0.8017942309379578,
        //         1.3438910245895386,
        //         0.7522174715995789,
        //         0.21996808052062988,
        //         1.945572853088379,
        //         2.1845650672912598,
        //         -0.5031641721725464,
        //         1.099493384361267
        //     ],
        //     [
        //         1.3205896615982056,
        //         0.22790785133838654,
        //         1.078640341758728,
        //         2.065321445465088,
        //         1.4010093212127686,
        //         0.7207836508750916,
        //         0.8984870314598083,
        //         0.3419042229652405,
        //         0.9071918725967407,
        //         0.3868916928768158,
        //         0.733816921710968,
        //         0.4940587878227234,
        //         1.626491904258728,
        //         0.2924858331680298,
        //         -0.39605948328971863,
        //         0.3842724859714508,
        //         1.4128026962280273,
        //         -0.2555575966835022,
        //         1.2420974969863892,
        //         -0.883922278881073,
        //         0.7803000807762146,
        //         1.0317245721817017,
        //         0.05735383927822113,
        //         1.401952862739563
        //     ],
        //     [
        //         -11.709433555603027,
        //         3.448369264602661,
        //         -11.097336769104004,
        //         -2.5098345279693604,
        //         -8.292670249938965,
        //         -13.595732688903809,
        //         -11.527029991149902,
        //         5.926766395568848,
        //         -7.046133041381836,
        //         4.463074684143066,
        //         1.174424648284912,
        //         -10.033348083496094,
        //         -11.340805053710938,
        //         1.7251850366592407,
        //         4.019810199737549,
        //         2.990457057952881,
        //         2.27421236038208,
        //         3.7083113193511963,
        //         -11.557060241699219,
        //         3.5875537395477295,
        //         -13.982269287109375,
        //         -14.602431297302246,
        //         3.1407599449157715,
        //         -14.827571868896484
        //     ],
        //     [
        //         0.9684721827507019,
        //         -0.9567154049873352,
        //         -0.021615171805024147,
        //         0.7368288636207581,
        //         1.22282075881958,
        //         -4.162357330322266,
        //         2.039325714111328,
        //         0.37830105423927307,
        //         1.0061057806015015,
        //         0.09665751457214355,
        //         0.6597211956977844,
        //         0.06017322093248367,
        //         1.8844949007034302,
        //         0.4441041350364685,
        //         -1.3350507020950317,
        //         0.12919925153255463,
        //         -0.9494094848632812,
        //         -0.933652937412262,
        //         1.1092857122421265,
        //         -0.6501222252845764,
        //         2.402970314025879,
        //         -0.028521958738565445,
        //         -0.475835919380188,
        //         1.256589651107788
        //     ],
        //     [
        //         -0.7172544002532959,
        //         0.615576446056366,
        //         -5.270991802215576,
        //         1.0026224851608276,
        //         -0.8253938555717468,
        //         -0.14936915040016174,
        //         3.8746323585510254,
        //         1.6791601181030273,
        //         1.6712349653244019,
        //         2.276423215866089,
        //         -1.845377802848816,
        //         1.281815767288208,
        //         -0.215121328830719,
        //         3.2496039867401123,
        //         -0.6528118252754211,
        //         0.905859649181366,
        //         -0.09673994779586792,
        //         1.0985413789749146,
        //         -5.176751613616943,
        //         1.1132696866989136,
        //         5.298501968383789,
        //         -4.895784854888916,
        //         1.0005124807357788,
        //         -3.129796028137207
        //     ],
        //     [
        //         -5.50979471206665,
        //         -1.5617107152938843,
        //         -4.242671012878418,
        //         -5.50615930557251,
        //         -6.466814994812012,
        //         -2.6306724548339844,
        //         -8.402604103088379,
        //         0.26379162073135376,
        //         -4.775277137756348,
        //         1.6428287029266357,
        //         -6.03589391708374,
        //         -1.8980885744094849,
        //         -0.8091463446617126,
        //         3.0469884872436523,
        //         -3.552081346511841,
        //         -1.795644998550415,
        //         0.580382227897644,
        //         6.227174282073975,
        //         -6.276956081390381,
        //         -0.01063200831413269,
        //         -7.966408729553223,
        //         -6.111107349395752,
        //         -0.32973378896713257,
        //         -6.739371299743652
        //     ],
        //     [
        //         -5.0604248046875,
        //         0.13220684230327606,
        //         1.8543424606323242,
        //         -0.3843192160129547,
        //         -2.4546141624450684,
        //         -0.8775633573532104,
        //         -2.0466654300689697,
        //         -0.47781848907470703,
        //         0.7231998443603516,
        //         2.1718227863311768,
        //         -3.0575122833251953,
        //         -3.7290890216827393,
        //         1.6042184829711914,
        //         1.121718406677246,
        //         0.4387515187263489,
        //         -0.5340996980667114,
        //         1.4831578731536865,
        //         0.016790056601166725,
        //         3.326770544052124,
        //         0.3676530718803406,
        //         4.354694843292236,
        //         1.5670931339263916,
        //         0.7958431839942932,
        //         -3.3467037677764893
        //     ],
        //     [
        //         -0.822321355342865,
        //         0.2604826092720032,
        //         0.8133530020713806,
        //         0.634041965007782,
        //         -2.081718921661377,
        //         0.7305664420127869,
        //         -4.159416675567627,
        //         -0.5425794124603271,
        //         -0.485565721988678,
        //         2.6864566802978516,
        //         -1.8667465448379517,
        //         -1.1737892627716064,
        //         -0.36483898758888245,
        //         1.5299327373504639,
        //         0.6650834083557129,
        //         -1.211294174194336,
        //         2.344656467437744,
        //         0.46370798349380493,
        //         0.48765525221824646,
        //         0.12344761192798615,
        //         3.9623544216156006,
        //         2.1882059574127197,
        //         1.8097652196884155,
        //         -3.694406270980835
        //     ],
        //     [
        //         -1.8283469676971436,
        //         1.5832759141921997,
        //         -1.6545326709747314,
        //         1.7484906911849976,
        //         0.7714712023735046,
        //         1.604058861732483,
        //         2.1791253089904785,
        //         1.302525520324707,
        //         0.567746102809906,
        //         2.2996230125427246,
        //         -3.438023805618286,
        //         -2.2672276496887207,
        //         4.496987819671631,
        //         1.5218933820724487,
        //         -0.017388012260198593,
        //         0.6068562269210815,
        //         3.7411458492279053,
        //         0.586588978767395,
        //         3.383538246154785,
        //         -1.7811204195022583,
        //         -3.3615736961364746,
        //         -3.945946216583252,
        //         1.5248266458511353,
        //         6.183060646057129
        //     ],
        //     [
        //         -1.9101307392120361,
        //         1.5672351121902466,
        //         -1.1993837356567383,
        //         1.568716287612915,
        //         -1.9637280702590942,
        //         1.7424451112747192,
        //         1.6071901321411133,
        //         0.12591136991977692,
        //         -5.301179885864258,
        //         1.7441383600234985,
        //         0.5533548593521118,
        //         5.165117263793945,
        //         1.2782779932022095,
        //         2.7458856105804443,
        //         0.7836309671401978,
        //         0.16510313749313354,
        //         2.1097092628479004,
        //         0.9923246502876282,
        //         3.0390732288360596,
        //         -0.6747525334358215,
        //         -2.4338583946228027,
        //         0.5973352789878845,
        //         1.0412092208862305,
        //         -2.9303464889526367
        //     ],
        //     [
        //         -0.35886093974113464,
        //         -1.0711790323257446,
        //         -0.8018397092819214,
        //         2.2472195625305176,
        //         -0.2547323405742645,
        //         -1.2068699598312378,
        //         -0.662876307964325,
        //         -0.24305079877376556,
        //         0.45404982566833496,
        //         0.2296542227268219,
        //         0.7858901023864746,
        //         0.7955016493797302,
        //         -1.1199491024017334,
        //         2.034775972366333,
        //         0.7971591353416443,
        //         1.9897938966751099,
        //         -1.4930272102355957,
        //         1.7808598279953003,
        //         -0.3249305784702301,
        //         1.2736724615097046,
        //         0.252833753824234,
        //         1.804606556892395,
        //         0.7773964405059814,
        //         0.35463473200798035
        //     ],
        //     [
        //         0.5755221247673035,
        //         0.48037460446357727,
        //         -0.36268678307533264,
        //         1.4692699909210205,
        //         -0.6136266589164734,
        //         -0.10416698455810547,
        //         2.9237167835235596,
        //         0.9100657105445862,
        //         -3.677903175354004,
        //         1.0722336769104004,
        //         1.1470963954925537,
        //         2.476576566696167,
        //         -0.29501524567604065,
        //         1.5706243515014648,
        //         1.1119688749313354,
        //         -0.31394898891448975,
        //         0.8883726000785828,
        //         -1.0701828002929688,
        //         3.608590841293335,
        //         -0.704870879650116,
        //         -0.9470258951187134,
        //         0.3351796865463257,
        //         1.484681487083435,
        //         -3.5001721382141113
        //     ],
        //     [
        //         3.3485348224639893,
        //         0.96633380651474,
        //         4.0846099853515625,
        //         3.0586042404174805,
        //         5.314487934112549,
        //         1.211072564125061,
        //         -2.5569372177124023,
        //         -3.6462795734405518,
        //         -1.281952142715454,
        //         2.2995665073394775,
        //         0.3908262550830841,
        //         -1.3308604955673218,
        //         1.5395900011062622,
        //         3.0327868461608887,
        //         0.9207255244255066,
        //         0.7713736891746521,
        //         1.7159342765808105,
        //         1.022119402885437,
        //         -2.487516403198242,
        //         1.0456103086471558,
        //         -1.3899167776107788,
        //         -4.017914295196533,
        //         2.081852674484253,
        //         -2.826282024383545
        //     ],
        //     [
        //         1.097206711769104,
        //         -0.4557645320892334,
        //         1.1800594329833984,
        //         1.3580716848373413,
        //         1.267151951789856,
        //         -1.1361018419265747,
        //         1.3419150114059448,
        //         -3.28023624420166,
        //         1.6124194860458374,
        //         -0.16716918349266052,
        //         1.643646001815796,
        //         0.6211049556732178,
        //         1.0675534009933472,
        //         0.563510537147522,
        //         -2.268536329269409,
        //         -0.9692060351371765,
        //         1.270824909210205,
        //         0.9109257459640503,
        //         1.8781565427780151,
        //         -1.2009247541427612,
        //         1.522371768951416,
        //         0.5015612840652466,
        //         -1.194045066833496,
        //         1.504223108291626
        //     ],
        //     [
        //         1.3558467626571655,
        //         -0.3236102759838104,
        //         1.8180052042007446,
        //         0.5962472558021545,
        //         1.2633033990859985,
        //         -0.004050882067531347,
        //         1.0542012453079224,
        //         -0.6200582981109619,
        //         1.309576392173767,
        //         -0.6445831656455994,
        //         1.821542739868164,
        //         1.6528500318527222,
        //         1.2039070129394531,
        //         -1.1384799480438232,
        //         -0.6668269634246826,
        //         -0.7235439419746399,
        //         -0.8642497062683105,
        //         -1.471147894859314,
        //         0.9304599761962891,
        //         -0.9011414647102356,
        //         2.3477699756622314,
        //         2.2899656295776367,
        //         -1.1537950038909912,
        //         1.129063606262207
        //     ],
        //     [
        //         4.134111404418945,
        //         1.0200783014297485,
        //         1.770235300064087,
        //         0.38284048438072205,
        //         -3.8822133541107178,
        //         0.8889518976211548,
        //         0.11506128311157227,
        //         1.0146852731704712,
        //         0.6673757433891296,
        //         1.1524369716644287,
        //         -0.831250011920929,
        //         -0.5163359642028809,
        //         -4.0955634117126465,
        //         1.202041506767273,
        //         1.2008339166641235,
        //         0.07305790483951569,
        //         1.5476871728897095,
        //         -0.19491764903068542,
        //         -0.5095011591911316,
        //         -2.5963237285614014,
        //         -0.10004328936338425,
        //         -1.0751537084579468,
        //         3.229844331741333,
        //         -0.47923287749290466
        //     ],
        //     [
        //         -1.250232458114624,
        //         0.5905649065971375,
        //         -0.08256929367780685,
        //         0.9054294228553772,
        //         0.27175965905189514,
        //         2.6444907188415527,
        //         1.0862230062484741,
        //         1.7406926155090332,
        //         1.0049235820770264,
        //         0.5723413228988647,
        //         0.45481130480766296,
        //         1.066864252090454,
        //         0.9283227324485779,
        //         0.2744450271129608,
        //         -0.3252626657485962,
        //         -1.4832520484924316,
        //         -0.45937055349349976,
        //         0.9746733903884888,
        //         0.5272085666656494,
        //         1.7287968397140503,
        //         0.40107712149620056,
        //         0.4439826011657715,
        //         1.5116416215896606,
        //         1.5723758935928345
        //     ],
        //     [
        //         0.9248763918876648,
        //         1.447110891342163,
        //         1.2569127082824707,
        //         0.13202568888664246,
        //         1.23287034034729,
        //         -0.09431985020637512,
        //         -0.20055058598518372,
        //         0.9811994433403015,
        //         1.1800695657730103,
        //         -0.6481343507766724,
        //         0.6477194428443909,
        //         1.4359490871429443,
        //         0.4489688277244568,
        //         -2.0626895427703857,
        //         3.5341994762420654,
        //         0.38320192694664,
        //         0.11111105978488922,
        //         -1.7785009145736694,
        //         0.3654748201370239,
        //         0.8717004656791687,
        //         0.7262043952941895,
        //         1.6146215200424194,
        //         0.24619705975055695,
        //         1.2802846431732178
        //     ],
        //     [
        //         1.0777146816253662,
        //         0.6887889504432678,
        //         0.9763043522834778,
        //         1.0912832021713257,
        //         1.6754050254821777,
        //         2.861457586288452,
        //         0.9644241333007812,
        //         0.5982322096824646,
        //         1.041653037071228,
        //         0.2874344289302826,
        //         1.1167256832122803,
        //         0.33687469363212585,
        //         -0.4786717891693115,
        //         -0.36680084466934204,
        //         0.19943539798259735,
        //         -1.200127124786377,
        //         -0.5142126083374023,
        //         0.7692820429801941,
        //         0.6361661553382874,
        //         1.5032871961593628,
        //         1.4838706254959106,
        //         1.1542298793792725,
        //         0.17455990612506866,
        //         0.9212511777877808
        //     ],
        //     [
        //         4.860254287719727,
        //         -0.25654035806655884,
        //         2.73272442817688,
        //         -0.4675641357898712,
        //         -6.920983791351318,
        //         -0.36660873889923096,
        //         1.1785703897476196,
        //         -1.0171481370925903,
        //         2.4884424209594727,
        //         2.0805416107177734,
        //         -1.0568853616714478,
        //         -0.25894537568092346,
        //         -3.7637181282043457,
        //         2.176224708557129,
        //         0.9384779930114746,
        //         1.6383451223373413,
        //         -0.2375909835100174,
        //         1.563838243484497,
        //         1.846806287765503,
        //         1.3428863286972046,
        //         -1.435538411140442,
        //         -2.1141557693481445,
        //         -0.3165300488471985,
        //         1.7748430967330933
        //     ],
        //     [
        //         2.769883871078491,
        //         1.8943456411361694,
        //         0.3640352189540863,
        //         1.785844326019287,
        //         0.7344745397567749,
        //         0.39368563890457153,
        //         -2.3875362873077393,
        //         0.8995029330253601,
        //         1.6547513008117676,
        //         1.3176071643829346,
        //         -0.9724606871604919,
        //         2.93916654586792,
        //         2.3889293670654297,
        //         -1.1804139614105225,
        //         4.386131763458252,
        //         0.7749289274215698,
        //         0.19975459575653076,
        //         -2.9396250247955322,
        //         -0.43144774436950684,
        //         2.340695381164551,
        //         1.5396018028259277,
        //         1.726706624031067,
        //         2.3074934482574463,
        //         1.5196326971054077
        //     ],
        //     [
        //         1.7053111791610718,
        //         0.47502008080482483,
        //         1.0501796007156372,
        //         -2.0408339500427246,
        //         -0.13104568421840668,
        //         0.33137980103492737,
        //         0.04775332286953926,
        //         2.4728024005889893,
        //         -1.4185632467269897,
        //         1.384668231010437,
        //         -0.7048049569129944,
        //         -1.0509675741195679,
        //         0.5553595423698425,
        //         0.8570550084114075,
        //         1.1651074886322021,
        //         0.7824841737747192,
        //         -1.3527337312698364,
        //         -0.7139086127281189,
        //         -1.1417115926742554,
        //         0.9422053098678589,
        //         -0.7971199750900269,
        //         -0.2167477160692215,
        //         1.5796117782592773,
        //         0.16019374132156372
        //     ]
        // ];

        // this.bias2 = [
        //     0.7284606099128723,
        //     1.7093586921691895,
        //     0.6005273461341858,
        //     1.239460825920105,
        //     1.928109884262085,
        //     -0.027622666209936142,
        //     0.5783648490905762,
        //     0.9252995252609253,
        //     2.127122402191162
        // ];
        // this.weight2 = [
        //         [
        //             1.9749627113342285,
        //             0.2404414713382721,
        //             4.499286651611328,
        //             -1.0144044160842896,
        //             2.829622983932495,
        //             -0.057477254420518875,
        //             -3.6028494834899902,
        //             -0.07592786103487015,
        //             -2.284479856491089
        //         ],
        //         [
        //             2.9142587184906006,
        //             0.14349043369293213,
        //             0.034647803753614426,
        //             1.630078911781311,
        //             0.21582122147083282,
        //             1.035940170288086,
        //             1.7996511459350586,
        //             -0.12669681012630463,
        //             0.29656586050987244
        //         ],
        //         [
        //             0.07991915196180344,
        //             -3.312174081802368,
        //             2.0938096046447754,
        //             -1.237191915512085,
        //             3.0206546783447266,
        //             -0.018381912261247635,
        //             4.422645568847656,
        //             -4.032643795013428,
        //             0.5288013815879822
        //         ],
        //         [
        //             -0.3284018635749817,
        //             2.989541530609131,
        //             -0.6642281413078308,
        //             0.5154777765274048,
        //             1.8245141506195068,
        //             0.9808709025382996,
        //             -0.8129456043243408,
        //             0.3030719757080078,
        //             -1.020087480545044
        //         ],
        //         [
        //             0.016836216673254967,
        //             1.6461126804351807,
        //             -4.328018665313721,
        //             -0.021215196698904037,
        //             4.4825334548950195,
        //             -0.7261971831321716,
        //             -1.5536736249923706,
        //             0.07121726870536804,
        //             0.6052526831626892
        //         ],
        //         [
        //             -0.5535260438919067,
        //             -0.7827446460723877,
        //             -0.8992803692817688,
        //             -0.24288810789585114,
        //             -0.3411737382411957,
        //             -0.6795476078987122,
        //             -0.8662106394767761,
        //             -0.9232723116874695,
        //             11.626473426818848
        //         ],
        //         [
        //             -2.5547831058502197,
        //             -1.029831886291504,
        //             0.7786807417869568,
        //             1.6619913578033447,
        //             -2.1873247623443604,
        //             2.495579719543457,
        //             -1.6966722011566162,
        //             4.159885406494141,
        //             -0.21722158789634705
        //         ],
        //         [
        //             3.440404176712036,
        //             -0.9836574792861938,
        //             0.17408487200737,
        //             0.6699033379554749,
        //             -2.6936252117156982,
        //             0.6502456665039062,
        //             0.9803906679153442,
        //             0.1889471560716629,
        //             2.7631726264953613
        //         ],
        //         [
        //             0.7359793186187744,
        //             -2.7816343307495117,
        //             2.2713539600372314,
        //             1.0174250602722168,
        //             -1.2494703531265259,
        //             -5.437539577484131,
        //             -0.5791329741477966,
        //             1.608538031578064,
        //             3.1371114253997803
        //         ],
        //         [
        //             1.364742398262024,
        //             0.9572967886924744,
        //             1.9356130361557007,
        //             0.8062270879745483,
        //             1.4080042839050293,
        //             1.1558339595794678,
        //             1.9050817489624023,
        //             1.6431550979614258,
        //             1.0936533212661743
        //         ],
        //         [
        //             -1.6878529787063599,
        //             -0.20728130638599396,
        //             -0.5994408130645752,
        //             -1.8281294107437134,
        //             0.24465569853782654,
        //             1.4410701990127563,
        //             -2.161224603652954,
        //             -0.4612058699131012,
        //             2.589486837387085
        //         ],
        //         [
        //             2.5645225048065186,
        //             -2.414802074432373,
        //             -0.5029224753379822,
        //             -2.476569652557373,
        //             -0.8130285739898682,
        //             4.222813606262207,
        //             -3.7621500492095947,
        //             1.437982439994812,
        //             -0.41775432229042053
        //         ],
        //         [
        //             2.431997537612915,
        //             -3.6574742794036865,
        //             -3.21728777885437,
        //             3.985774040222168,
        //             1.010752558708191,
        //             0.5697790384292603,
        //             1.6467233896255493,
        //             0.7546154856681824,
        //             -1.334580898284912
        //         ],
        //         [
        //             -2.827427625656128,
        //             1.7032489776611328,
        //             2.11814284324646,
        //             0.30391034483909607,
        //             2.579265832901001,
        //             0.23728306591510773,
        //             0.9366695880889893,
        //             2.0961742401123047,
        //             0.4443163573741913
        //         ],
        //         [
        //             6.536571979522705,
        //             0.3252210021018982,
        //             0.47008466720581055,
        //             0.3100663721561432,
        //             -0.746806800365448,
        //             0.5565483570098877,
        //             0.07242288440465927,
        //             -0.04018740355968475,
        //             1.5937074422836304
        //         ],
        //         [
        //             2.4231934547424316,
        //             1.1276671886444092,
        //             1.4375793933868408,
        //             0.6470419764518738,
        //             1.408554196357727,
        //             0.9919240474700928,
        //             1.220597267150879,
        //             0.9893061518669128,
        //             0.29316332936286926
        //         ],
        //         [
        //             0.6666469573974609,
        //             -0.6954585909843445,
        //             0.5175284743309021,
        //             3.3031747341156006,
        //             2.2068967819213867,
        //             1.4418079853057861,
        //             1.4853301048278809,
        //             0.06092767417430878,
        //             -0.5447710156440735
        //         ],
        //         [
        //             -3.4399025440216064,
        //             0.2934260964393616,
        //             1.5721722841262817,
        //             0.8964863419532776,
        //             1.0936353206634521,
        //             0.4710237979888916,
        //             1.1171822547912598,
        //             1.1114387512207031,
        //             2.749636650085449
        //         ],
        //         [
        //             -1.2879736423492432,
        //             -0.8956615328788757,
        //             1.2662760019302368,
        //             1.830581545829773,
        //             -1.7124319076538086,
        //             2.5808987617492676,
        //             1.9343351125717163,
        //             -4.504626274108887,
        //             -0.8327578902244568
        //         ],
        //         [
        //             3.2626099586486816,
        //             1.2724570035934448,
        //             1.443620204925537,
        //             -0.3940924406051636,
        //             0.844620943069458,
        //             0.6732372641563416,
        //             0.3383709490299225,
        //             1.6434345245361328,
        //             2.399984836578369
        //         ],
        //         [
        //             -0.4097330868244171,
        //             -0.4845009744167328,
        //             -1.524335503578186,
        //             -2.7316455841064453,
        //             -1.4284635782241821,
        //             -1.596526026725769,
        //             4.845731258392334,
        //             4.008439540863037,
        //             -1.7798140048980713
        //         ],
        //         [
        //             -0.27366065979003906,
        //             3.3561480045318604,
        //             -0.7407917976379395,
        //             -2.1552276611328125,
        //             -2.4002108573913574,
        //             0.45311087369918823,
        //             2.201896905899048,
        //             -2.589961051940918,
        //             0.7544904351234436
        //         ],
        //         [
        //             1.6875838041305542,
        //             1.6762372255325317,
        //             0.4864174723625183,
        //             1.1023706197738647,
        //             -0.4291389286518097,
        //             1.6483114957809448,
        //             0.723427414894104,
        //             1.231937289237976,
        //             2.2384915351867676
        //         ],
        //         [
        //             -0.016140121966600418,
        //             2.6373164653778076,
        //             1.066977858543396,
        //             3.566697835922241,
        //             -1.8497729301452637,
        //             -2.677297592163086,
        //             -2.330751895904541,
        //             -1.3379294872283936,
        //             -0.9855337142944336
        //         ]
        //     ]
                            
        // в форме буквы N
        
        let strN = ` <table id = "crestField">
                <tr><td  id="c0"></td><td class="empty"></td><td class="empty"></td><td id="c1"></td></tr>
                <tr><td id="c2"></td><td id="c3"></td><td class="empty"></td><td id="c4"></td></tr>
                <tr><td id="c5"></td><td class="empty"></td><td id="c6"></td><td id="c7"></td></tr>
                <tr><td id="c8"></td><td class="empty"></td><td class="empty"></td><td id="c9"></td></tr>
            </table>
            <div id = "cardSet"></div>`

        // крест, вписанный в квадрат 4 на 4 с основанием в две ячейки
        // и перекладиной, толщиной в одну ячейку, смещенной кверху,
        // решено вручную для синей колоды(карты в порядке возрастания) 
        // и для зелёной колоды(карты идут парами одной масти по возрастанию),
        // с красной колодой прошёл с первого раза, с чёрной колодой
        // раза с третьего с -1500
        let strCrest =`
            <table id = "crestField">
                <tr><td class="empty"></td><td id="c0"></td><td id="c1"></td><td class="empty"></td></tr>
                <tr><td id="c2"></td><td id="c3"></td><td id="c4"></td><td id="c5"></td></tr>
                <tr><td class="empty"></td><td id="c6"></td><td id="c7"></td><td class="empty"></td></tr>
                <tr><td class="empty"></td><td id="c8"></td><td id="c9"></td><td class="empty"></td></tr>
            </table>
            <div id = "cardSet"></div>
        `
        
        

        // треугольное поле с треугольником в левом нижнем углу,
        // решено вручную для синей колоды(карты в порядке возрастания) и
        // для зелёной колоды(карты идут парами одной масти по возрастанию)
        // с красной колодой прошёл с первого раза, с чёрной раза с пятого
        // с результатом -1000
        // для шестой скрытой c первого раза
        // для пятой скрытой раза с третьего
        let strTriangle =`<table id = "crestField">
                <tr><td  id="c0"></td><td class="empty"></td><td class="empty"></td><td class="empty"></td></tr>
                <tr><td id="c1"></td><td id="c2"></td><td class="empty"></td><td class="empty"></td></tr>
                <tr><td id="c3"></td><td id="c4"></td><td id="c5"></td><td class="empty"></td></tr>
                <tr><td id="c6"></td><td id="c7"></td><td id="c8"></td><td id="c9"></td></tr>
            </table>
            <div id = "cardSet"></div>
        `
        // в форме буквы H, вручную для синей колоды сложил с тремя оставшимися
        // картами 6, король,туз, с зелёной колодой сложил с четырьмя картами
        // в остатке, с красной колодой прошёл раза с пятнадцатого
        // для пятой скрытой - раза с третьего
        let strH = ` <table id = "crestField">
                <tr><td  id="c0"></td><td class="empty"></td><td id="c1"></td></tr>
                <tr><td id="c2"></td><td id="c3"></td></td><td id="c4"></td></tr>
                <tr><td id="c5"></td><td class="empty"></td><td id="c6"></td></tr>
                <tr><td id="c7"></td><td class="empty"></td><td id="c8"></td></tr>
            </table>
            <div id = "cardSet"></div>`

        // пирамида, решено вручную для синей колоды(карты в порядке возрастания) 
        // и для зелёной колоды(карты идут парами одной масти по возрастанию)
        // для шестой скрытой - раза с третьего
        // для пятой скрытой - раза с третьего
        let strPyramid =`
            <table id = "crestField">
                <tr><td class="empty"></td><td class="empty"></td><td id="c0"></td><td class="empty"><td class="empty"></td></tr>
                <tr><td class="empty"></td><td id="c1"></td><td id="c2"></td><td id="c3"></td><td class="empty"></tr>
                <tr><td id="c4"></td><td id="c5"></td><td id="c6"></td><td id="c7"></td><td id="c8"></tr>
            </table>
            <div id = "cardSet"></div>
        `

        // лесенка, нумерация сверху вниз слева направо, с синей колодой сложил
        // под нуль, причём самая верхняя правая ячейка(c1) не нужна
        // для зелёной колоды также всё сложил без той же ячейки(с1)
        // для красной колоды сложил раза с пятого
        // для шестой скрытой - раза с третьего
        let strStair =`
            <table id = "crestField">
                <tr><td class="empty"></td><td class="empty"></td><td id="c0"></td><td id="c1"></td></tr>
                <tr><td class="empty"></td><td id="c2"></td><td id="c3"></td><td id="c4"></td></tr>
                <tr><td id="c5"></td><td id="c6"></td><td id="c7"></td><td class="empty"></td></tr>
                <tr><td id="c8"></td><td id="c9"></td><td class="empty"></td><td class="empty"></td></tr>
            </table>
            <div id = "cardSet"></div>
        `

        let strRomb =`<table id = "crestField">
                <tr><td class="empty"></td><td class="empty"></td><td id="c0"></td><td class="empty"></td><td class="empty"></td></tr>
                <tr><td class="empty"></td><td id="c1"></td><td id="c2"></td><td id="c3"></td><td class="empty"></td></tr>
                <tr><td id="c4"></td><td id="c5"></td><td class="empty"></td><td id="c6"></td><td class="empty"></td></tr>
                <tr><td class="empty"></td><td id="c7"></td><td id="c8"></td><td id="c9"></td><td class="empty"></td></tr>
                <tr><td class="empty"></td><td class="empty"></td><td class="empty"></td><td class="empty"></td><td class="empty"></td></tr>
            </table>
            <div id = "cardSet"></div>
        `

        // с красной колодой прошёл раза с третьего
        let strRombMirr =`<table id = "crestField">
                <tr><td class="empty"></td><td class="empty"></td><td id="c0"></td><td class="empty"></td><td class="empty"></td></tr>
                <tr><td class="empty"></td><td id="c1"></td><td id="c2"></td><td id="c3"></td><td class="empty"></td></tr>
                <tr><td id="c4"></td><td id="c5"></td><td class="empty"></td><td id="c6"></td><td class="empty"></td></tr>
                <tr><td class="empty"></td><td id="c7"></td><td id="c8"></td><td id="c9"></td><td class="empty"></td></tr>
                <tr><td class="empty"></td><td class="empty"></td><td class="empty"></td><td class="empty"></td><td class="empty"></td></tr>
            </table>
            <div id = "cardSet"></div>
        `
        
        // решено вручную для синей колоды(карты в порядке возрастания) и
        // для зелёной колоды(карты идут парами одной масти по возрастанию)
        // с красной колодой прошёл раза с третьего, с чёрной колодой
        // раза с третьего с -1400
        // для шестой скрытой - раза с третьего
        let strSquare =`<table id = "crestField">
                <tr><td id="c0"></td><td id="c1"></td><td id="c2"></td></tr>
                <tr><td id="c3"></td><td id="c4"></td><td id="c5"></td></tr>
                <tr><td id="c6"></td><td id="c7"></td><td id="c8"></td></tr>
            </table>
            <div id = "cardSet"></div>
        `

        let strSquareMirr =`<table id = "crestField">
                <tr><td id="c0"></td><td id="c1"></td><td id="c2"></td></tr>
                <tr><td id="c3"></td><td id="c4"></td><td id="c5"></td></tr>
                <tr><td id="c6"></td><td id="c7"></td><td id="c8"></td></tr>
            </table>
            <div id = "cardSet"></div>
        `
        body[0].innerHTML = strSquare
        //'<div id="btnDiv">Открыть.</div>'
        

        this.cardSet = []
        let gf = document.getElementById("crestField") as HTMLTableElement
        this.cardSetDiv = document.getElementById("cardSet") as HTMLDivElement
        this.gameField = [0,0,0,0,0,0,0,0,0]
        this.observ = [0,0,0,0,0,0,0,0,0,0,0]
        this.fieldView = []
        this.counter = 0
        //document.body.append('<div id="btnDiv">Открыть.</div>')
        let el = document.getElementById("cardSet")

        // для варианта с кнопкрй отмены
        //el.insertAdjacentHTML("afterend",'<div id="btnDiv"><button>Открыть.</button></div>')
        //el.insertAdjacentHTML("afterend",'<div id="counterDiv"><span id="counterSpan">0</span></div>')
        gf.addEventListener("click", (ev) =>{ this.handleClick(ev); })
        //document.getElementById("btnDiv").addEventListener("click",(ev) => {this.btnHundle(ev);})
    }

    init() {
        /** набор карт для зелёной колоды */
        // for (let i = 0; i < 4; i++) {
        //     this.cardSet.push(1)
        //     this.cardSet.push(1)
        //     this.cardSet.push(2)
        //     this.cardSet.push(2)
        //     this.cardSet.push(3)
        //     this.cardSet.push(3)
        //     this.cardSet.push(4)
        //     this.cardSet.push(4)
        // }

        // this.cardSet.push(1)
        // this.cardSet.push(2)
        // this.cardSet.push(3)
        // this.cardSet.push(4)

        /** набор карт для зелёной колоды */
        for (let i = 0; i < 9; i++) {
            this.cardSet.push(1)
            this.cardSet.push(2)
            this.cardSet.push(3)
            this.cardSet.push(4)
        }

        // this.cardSet = this.cardSet.concat(this.cardSet)

        this.cardSet = this.shuffle(this.cardSet)
        //this.cardSetDiv.innerHTML = this.cardSet.toString()
        this.cardSetDiv.innerHTML = this.cardSet[0]+"" + this.cardSet[1] + 
            this.cardSet[2] + this.cardSet[3] + this.cardSet[4] + this.cardSet[5] ;
        
        //this.cardSetDiv.innerHTML = this.shufledCardSet.toString()

        //this.cardSetDiv.innerHTML = this.cardSet[0].toString()

        this.cardSetDiv.innerHTML = this.cardSet.slice(0,4).toString()

        this.gameField.forEach((val, ind) => {
            let el = (document.getElementById("c" + ind) as HTMLElement)
            this.fieldView.push(el)
            el.innerHTML = '' + 0
        })

        let step = this.predict()
        let numStep = this.cardSet.length%2
        this.cardSetDiv.innerHTML = this.cardSetDiv.innerHTML +'('+numStep+')';
    }

    shuffle(array: number[]): number[] {  
        const shuffledArray = [...array];  
        for (let i = shuffledArray.length - 1; i > 0; i--) {  
            const j = Math.floor(Math.random() * (i + 1));  
            [shuffledArray[i], shuffledArray[j]] = [shuffledArray[j], shuffledArray[i]];  
        }  
        return shuffledArray;  
    }


    handleClick(ev) {
        if ((ev.target as HTMLElement).tagName == "TD") {
            let key = (ev.target as HTMLTableCellElement)?.id
            if (key == "empty") return
            if(ev.target.innerHTML != "0"){
                ev.target.innerHTML = "0"
                return
            }
            //src = ev.target as HTMLTableCellElement
            let card = this.cardSet.shift()
            this.numUsedCards++
            //let card = this.shufledCardSet.shift()
            //this.cardSetDiv.innerHTML = this.cardSet.toString()

            //скрываем каждую нечётную карту(для случая кнопки с отменой)
            // if(this.cardSet.length%2 != 0){
            //     this.cardSetDiv.innerHTML = 'H';
            // }else{
            //     this.cardSetDiv.innerHTML = this.cardSet[0]+'';
            // }
            
            //this.cardSetDiv.innerHTML = this.shufledCardSet.toString()
            //src.innerHTML = card

            let subArr:Array<number>;
            /* участок кода для набора из 6 видимых (за исключением скрытых) карт
            subArr = this.cardSet.length>5? this.cardSet.slice(0,6):
                this.cardSet.slice(0,this.cardSet.length);
            let rem = this.numUsedCards%5
            let indOfHiddenCard = 4 -rem
            if(subArr.length-1 >= indOfHiddenCard) subArr[indOfHiddenCard] = 8
            */

            // участок кода для одной видимой карты
            if(this.cardSet.length>=4){
                subArr = this.cardSet.slice(0,4)
                this.cardSetDiv.innerHTML = subArr.toString();
            }else{
                subArr = this.cardSet.slice(0,this.cardSet.length)
                this.cardSetDiv.innerHTML = subArr.toString()
            }

            //let str = '';
            // if(this.numUsedCards%3 == 1){
            //     // для случае когда каждая третья карта скрыта
            //     if(subArr.length > 4){
            //         subArr[1] = 8;
            //         subArr[4] = 8;
            //     }else if(subArr.length > 2){
            //         subArr[1] = 8
            //     }
            //     // str = this.cardSet.length > 0? str + this.cardSet[0] + "H":"";
            //     // str = this.cardSet.length > 2? str + this.cardSet[2] + "H":"";
            //     // str = this.cardSet.length > 4? str + this.cardSet[4] + "H":"";
            //     // str = this.cardSet[0] + "H" + 
            //     //     this.cardSet[2] + "H" + this.cardSet[4] + "H";
            // }else if(this.numUsedCards%3 == 2){
            //     // для случае когда каждая третья карта скрыта
            //     if(subArr.length > 3){
            //         subArr[0] = 8;
            //         subArr[3] = 8;
            //     }else if(this.cardSet.length > 3){
            //         subArr[0] = 8
            //     }
            //     // str = "H" + this.cardSet[1] + this.cardSet[2] +
            //     //     this.cardSet[3] + this.cardSet[4];
            //     // str = this.cardSet.length > 1? str + "H" + this.cardSet[1]:"";
            //     // str = this.cardSet.length > 3? str + "H" + this.cardSet[3]:"";
            //     // str = this.cardSet.length > 5? str + "H" + this.cardSet[5]:"";
            //     // str = "H" + this.cardSet[1] + 
            //     //     "H" + this.cardSet[3] + "H" + this.cardSet[5]  ;
            // }else if(this.numUsedCards%3 == 0){
            //     if(subArr.length > 5){
            //         subArr[2] = 8;
            //         subArr[5] = 8;
            //     }else if(this.cardSet.length > 3){
            //         subArr[2] = 8
            //     }
            //     // str = this.cardSet[0] + this.cardSet[1] + "H" +
            //     //     this.cardSet[3] + this.cardSet[4];
            // }

            //this.cardSetDiv.innerHTML = str;
            
            

            this.gameField[this.nameToInt[key]] = card
            this.fieldView[this.nameToInt[key]].innerHTML = '' + card;
            let step = this.predict()
            let numStep = this.cardSet.length%2
            this.cardSetDiv.innerHTML = this.cardSetDiv.innerHTML +'('+
                numStep+')';
            //addCardSq(nameToInt[key])
        }
        //console.log("clicked")
    }

    btnHundle(ev){
        if(this.cardSetDiv.innerHTML == "H"){
            this.cardSetDiv.innerHTML = this.cardSetDiv.innerHTML = "" +
                this.cardSet[0];
            this.counter += -100;
            document.getElementById("counterSpan").innerHTML = "" + this.counter;
        }
        //console.log(ev)
    }

    predict():number{
        let observArr:number[] = [...this.gameField]
        observArr[10] = cf.cardSet[0]
        observArr[9] = cf.numUsedCards;
        let afterLr0:number[] = new Array(24);
        let afterLr1:number[] = new Array(24);
        let afterLr2:number[] = new Array(9);

        for(let i=0;i<24;i++){
            afterLr0[i] = 0;
            for(let j=0;j<11;j++){
                afterLr0[i]+= (observArr[j]*weitsJS0[j][i]) 
            }
            afterLr0[i]+=biasJS0[i]
            afterLr0[i]= afterLr0[i]>0? afterLr0[i]:0;
        }

        for(let i=0;i<24;i++){
            afterLr1[i] = 0;
            for(let j=0;j<24;j++){
                afterLr1[i]+= (afterLr0[j]*weitsJS1[j][i]) 
            }
            afterLr1[i]+=biasJS1[i]
            afterLr1[i]= afterLr1[i]>0? afterLr1[i]:0;
        }

        for(let i=0;i<9;i++){
            afterLr2[i] = 0;
            for(let j=0;j<24;j++){
                afterLr2[i]+= (afterLr1[j]*weitsJS2[j][i]) 
            }
            afterLr2[i]+=biasJS2[i]
            //afterLr2[i]= afterLr2[i]>0? afterLr1[i]:0;
        }

        let step = afterLr2.reduce( (maxIndex, currentValue, currentIndex, array) => {
            let ret = (currentValue > array[maxIndex] ? currentIndex : maxIndex);
            return ret;
        },0)
        //let step = Math.max(...afterLr2)
        return step;
    }
}

let cf:CrestField = new CrestField(document)
cf.init()

// let coefJS ={
// "biasJS0":
// "[-1.8876183032989502, 6.374699592590332, -2.5466785430908203, 1.3777958154678345, 7.231475353240967, -2.348193645477295, 6.425029754638672, 5.493327617645264, 4.798320293426514, 3.808184862136841, 6.004950046539307, 4.979145050048828, -1.5610947608947754, 4.85793399810791, 6.049415588378906, -2.6042959690093994, -1.9762921333312988, 3.324725389480591, 2.1117634773254395, -2.3571741580963135, 0.632917046546936, 5.553223133087158, 3.863335132598877, 2.7057547569274902]",
// "biasJS1":
// "[0.25219589471817017, 2.199065923690796, 0.5163305997848511, 1.7737793922424316, 1.7355109453201294, 2.941150665283203, -1.904043197631836, 1.3057925701141357, 2.581031322479248, 3.102435827255249, 0.016762498766183853, -0.710008442401886, 0.1434781402349472, 2.637162685394287, 1.569477915763855, 0.7468231916427612, 1.7106614112854004, 2.1410746574401855, -1.6933093070983887, 1.7756812572479248, -1.6204744577407837, -0.7371547222137451, 2.9160404205322266, 0.9460389614105225]",
// "biasJS2":
// "[0.7284606099128723, 1.7093586921691895, 0.6005273461341858, 1.239460825920105, 1.928109884262085, -0.027622666209936142, 0.5783648490905762, 0.9252995252609253, 2.127122402191162]",
// "weightJS0":
// "[[1.3696094751358032, -0.07359838485717773, -0.09921309351921082, 0.18319395184516907, 0.14132151007652283, 0.5301502346992493, -0.0819331631064415, -3.569394826889038, -0.02796083688735962, -0.1774909496307373, -0.15207116305828094, 0.030718564987182617, -0.01001095212996006, -0.1908252239227295, -0.23479856550693512, 0.5857442617416382, 1.0813802480697632, -0.1974903643131256, 0.2849109172821045, -1.6279798746109009, 1.5406628847122192, -0.022876517847180367, -10.364359855651855, 1.2523927688598633], [1.3789832592010498, -8.527722358703613, 1.152313470840454, 0.452440083026886, 0.11718282103538513, 0.7991771697998047, -0.05951335281133652, -0.07699711620807648, -0.17663834989070892, 0.08331804722547531, -0.15681850910186768, -0.1676863431930542, -0.502187967300415, 0.04252010956406593, -0.0849909633398056, 0.6616184711456299, 0.28214865922927856, 0.05211364105343819, 0.20415425300598145, 0.7700093388557434, 1.9723950624465942, -0.12464689463376999, 0.06003753840923309, -1.1623634099960327], [0.2537570595741272, -0.10215749591588974, 0.040431275963783264, 0.03155476972460747, 0.027103165164589882, 0.37352097034454346, -0.11435843259096146, 0.19630534946918488, -0.044866278767585754, -0.14545594155788422, -0.15013177692890167, 0.2135411500930786, 0.3768550455570221, -0.4646220803260803, -0.1344188004732132, 0.9209727048873901, 0.8044061064720154, -6.327327728271484, 0.5275176763534546, 0.8194286823272705, 0.36879706382751465, -10.003642082214355, -0.10504879802465439, 0.3286918103694916], [-0.39051553606987, -0.11710388958454132, 0.4303794503211975, 0.8023504018783569, -0.013316864147782326, 0.4399143159389496, -0.11811403185129166, 0.20276710391044617, -0.4803994297981262, 0.4740790128707886, -6.534787178039551, -0.12082435935735703, 0.08868005871772766, -0.056319933384656906, -0.25063806772232056, 0.9675076007843018, -0.12375082820653915, 0.86045241355896, -0.10293815284967422, 1.3020009994506836, 0.5689107179641724, -0.75238436460495, -0.45310965180397034, -0.011035628616809845], [0.24613265693187714, -0.04076755791902542, 1.5536775588989258, 3.5746536254882812, 0.03602611646056175, 0.9254441857337952, -0.0469084270298481, 0.16096435487270355, 0.06483492255210876, -0.16002684831619263, -0.08755210787057877, 0.03184511885046959, 0.4527481496334076, -0.16493766009807587, -10.858072280883789, -0.821618378162384, 0.7585617899894714, -0.5106766223907471, 0.06864343583583832, 0.7410348653793335, 1.2198472023010254, 0.20073965191841125, -0.14772450923919678, -0.2561306059360504], [0.30025362968444824, -0.10373840481042862, 0.2623594105243683, 1.5273228883743286, 0.12371040135622025, 0.6276564002037048, -0.09851093590259552, 0.02600094862282276, -0.18113145232200623, 0.06524306535720825, -0.14326545596122742, -4.623420715332031, 0.3391391932964325, -6.048059463500977, -0.19630560278892517, 0.3487193286418915, 0.7955556511878967, 0.022290367633104324, 0.3051983118057251, 0.3594247102737427, 0.7958428263664246, -0.11982748657464981, -0.05950997397303581, 0.06777437776327133], [0.7801909446716309, -0.09248664230108261, 0.09940357506275177, -1.0153595209121704, 0.08435899764299393, 0.17075017094612122, -0.058232225477695465, 0.1554674506187439, -6.049262523651123, -6.28169584274292, -0.11218459159135818, -0.01949341781437397, 0.1391284167766571, -0.1721983700990677, -0.10752292722463608, 1.3590989112854004, 0.5789307355880737, 0.2001228630542755, 0.6304722428321838, 0.8294196128845215, 0.5981000065803528, -0.24533680081367493, -0.08334507793188095, 0.33822911977767944], [0.4243112802505493, -0.07566609978675842, 0.2720528841018677, 0.6740658283233643, 0.04756448045372963, 0.4649219512939453, -8.185419082641602, 0.4850037395954132, -0.09221773594617844, -0.021940255537629128, -0.22591866552829742, -0.09438097476959229, 0.5180769562721252, -0.07459632307291031, -0.1528426855802536, 1.1873703002929688, 0.7831243276596069, 0.0468844510614872, 1.0320607423782349, 0.9944241642951965, 0.35019612312316895, -0.1469622105360031, -0.14216791093349457, 0.5074479579925537], [3.8782236576080322, -0.18718546628952026, 0.7165839076042175, -1.7290457487106323, -0.06189868226647377, 3.872406482696533, -0.14245907962322235, 0.49688032269477844, -0.06976006180047989, -0.13838450610637665, -0.20591560006141663, -0.5521157383918762, 1.0798450708389282, 0.44237199425697327, -0.14923107624053955, 0.1432567983865738, 0.5238678455352783, -0.42558786273002625, -2.301241159439087, 1.5331969261169434, -4.5111165046691895, 0.08682422339916229, -0.021471181884407997, 0.31467169523239136], [1.4709402322769165, -0.3110193908214569, 3.198990821838379, 3.765214204788208, -4.054223537445068, 1.7444709539413452, -0.26419270038604736, -3.4829273223876953, -0.20377063751220703, -0.10610915720462799, -0.06005364656448364, -0.015929680317640305, 1.4432852268218994, -0.42064088582992554, -0.008017046377062798, 2.5457746982574463, 3.27333664894104, -0.0559917613863945, 2.164216995239258, 2.58890962600708, 2.826447010040283, -0.24300117790699005, 0.45977354049682617, -0.28474992513656616], [0.04838697612285614, -0.045141566544771194, -0.17020156979560852, 0.6914470195770264, 0.13812218606472015, 0.2917346656322479, -0.11371230334043503, 0.3606966435909271, 0.040266696363687515, -0.28789985179901123, 0.011608145199716091, -0.38051965832710266, 0.05977807939052582, 0.39741426706314087, -0.019623063504695892, -0.2557132840156555, 1.2935289144515991, -0.10882838070392609, -0.15287373960018158, -0.41121965646743774, 0.6207700967788696, 0.0022345196921378374, 0.3440141975879669, -0.09529685974121094]]",
// "weightJS1":
// "[[0.27257591485977173, 0.3869185745716095, 0.8504434823989868, 0.19986295700073242, 2.1833624839782715, -2.6583521366119385, 0.6577317118644714, 0.9097495079040527, 0.406642347574234, 0.16003330051898956, 0.9642981290817261, -0.19441643357276917, -0.18689903616905212, -0.5865878462791443, -0.2617162764072418, -0.20887833833694458, 1.284202218055725, -0.3069278597831726, 1.2351911067962646, -1.7140767574310303, -0.32893723249435425, 1.1261017322540283, 1.743562936782837, 0.9930200576782227], [-1.6525824069976807, 1.2020946741104126, -6.121692657470703, 2.8772192001342773, 0.4645692706108093, -0.2366919219493866, -3.779074192047119, 0.9434119462966919, -5.990158557891846, 1.4997889995574951, -2.4981682300567627, -4.219113349914551, -6.6248459815979, 2.3648576736450195, 0.5727714896202087, 1.6934337615966797, 0.15005964040756226, 0.6258471608161926, -3.500897169113159, 0.19448702037334442, -1.5161558389663696, 4.475485801696777, 0.5340183973312378, 3.2061800956726074], [0.6907560229301453, -0.978337824344635, 0.5097180604934692, 0.7867669463157654, -0.7426729202270508, -0.4525175392627716, 1.2939410209655762, -0.6715952157974243, 1.1685162782669067, 0.015682462602853775, 1.8083608150482178, 1.4117552042007446, -0.3204834759235382, 1.3994818925857544, -0.281608909368515, 1.6220496892929077, -0.8017942309379578, 1.3438910245895386, 0.7522174715995789, 0.21996808052062988, 1.945572853088379, 2.1845650672912598, -0.5031641721725464, 1.099493384361267], [1.3205896615982056, 0.22790785133838654, 1.078640341758728, 2.065321445465088, 1.4010093212127686, 0.7207836508750916, 0.8984870314598083, 0.3419042229652405, 0.9071918725967407, 0.3868916928768158, 0.733816921710968, 0.4940587878227234, 1.626491904258728, 0.2924858331680298, -0.39605948328971863, 0.3842724859714508, 1.4128026962280273, -0.2555575966835022, 1.2420974969863892, -0.883922278881073, 0.7803000807762146, 1.0317245721817017, 0.05735383927822113, 1.401952862739563], [-11.709433555603027, 3.448369264602661, -11.097336769104004, -2.5098345279693604, -8.292670249938965, -13.595732688903809, -11.527029991149902, 5.926766395568848, -7.046133041381836, 4.463074684143066, 1.174424648284912, -10.033348083496094, -11.340805053710938, 1.7251850366592407, 4.019810199737549, 2.990457057952881, 2.27421236038208, 3.7083113193511963, -11.557060241699219, 3.5875537395477295, -13.982269287109375, -14.602431297302246, 3.1407599449157715, -14.827571868896484], [0.9684721827507019, -0.9567154049873352, -0.021615171805024147, 0.7368288636207581, 1.22282075881958, -4.162357330322266, 2.039325714111328, 0.37830105423927307, 1.0061057806015015, 0.09665751457214355, 0.6597211956977844, 0.06017322093248367, 1.8844949007034302, 0.4441041350364685, -1.3350507020950317, 0.12919925153255463, -0.9494094848632812, -0.933652937412262, 1.1092857122421265, -0.6501222252845764, 2.402970314025879, -0.028521958738565445, -0.475835919380188, 1.256589651107788], [-0.7172544002532959, 0.615576446056366, -5.270991802215576, 1.0026224851608276, -0.8253938555717468, -0.14936915040016174, 3.8746323585510254, 1.6791601181030273, 1.6712349653244019, 2.276423215866089, -1.845377802848816, 1.281815767288208, -0.215121328830719, 3.2496039867401123, -0.6528118252754211, 0.905859649181366, -0.09673994779586792, 1.0985413789749146, -5.176751613616943, 1.1132696866989136, 5.298501968383789, -4.895784854888916, 1.0005124807357788, -3.129796028137207], [-5.50979471206665, -1.5617107152938843, -4.242671012878418, -5.50615930557251, -6.466814994812012, -2.6306724548339844, -8.402604103088379, 0.26379162073135376, -4.775277137756348, 1.6428287029266357, -6.03589391708374, -1.8980885744094849, -0.8091463446617126, 3.0469884872436523, -3.552081346511841, -1.795644998550415, 0.580382227897644, 6.227174282073975, -6.276956081390381, -0.01063200831413269, -7.966408729553223, -6.111107349395752, -0.32973378896713257, -6.739371299743652], [-5.0604248046875, 0.13220684230327606, 1.8543424606323242, -0.3843192160129547, -2.4546141624450684, -0.8775633573532104, -2.0466654300689697, -0.47781848907470703, 0.7231998443603516, 2.1718227863311768, -3.0575122833251953, -3.7290890216827393, 1.6042184829711914, 1.121718406677246, 0.4387515187263489, -0.5340996980667114, 1.4831578731536865, 0.016790056601166725, 3.326770544052124, 0.3676530718803406, 4.354694843292236, 1.5670931339263916, 0.7958431839942932, -3.3467037677764893], [-0.822321355342865, 0.2604826092720032, 0.8133530020713806, 0.634041965007782, -2.081718921661377, 0.7305664420127869, -4.159416675567627, -0.5425794124603271, -0.485565721988678, 2.6864566802978516, -1.8667465448379517, -1.1737892627716064, -0.36483898758888245, 1.5299327373504639, 0.6650834083557129, -1.211294174194336, 2.344656467437744, 0.46370798349380493, 0.48765525221824646, 0.12344761192798615, 3.9623544216156006, 2.1882059574127197, 1.8097652196884155, -3.694406270980835], [-1.8283469676971436, 1.5832759141921997, -1.6545326709747314, 1.7484906911849976, 0.7714712023735046, 1.604058861732483, 2.1791253089904785, 1.302525520324707, 0.567746102809906, 2.2996230125427246, -3.438023805618286, -2.2672276496887207, 4.496987819671631, 1.5218933820724487, -0.017388012260198593, 0.6068562269210815, 3.7411458492279053, 0.586588978767395, 3.383538246154785, -1.7811204195022583, -3.3615736961364746, -3.945946216583252, 1.5248266458511353, 6.183060646057129], [-1.9101307392120361, 1.5672351121902466, -1.1993837356567383, 1.568716287612915, -1.9637280702590942, 1.7424451112747192, 1.6071901321411133, 0.12591136991977692, -5.301179885864258, 1.7441383600234985, 0.5533548593521118, 5.165117263793945, 1.2782779932022095, 2.7458856105804443, 0.7836309671401978, 0.16510313749313354, 2.1097092628479004, 0.9923246502876282, 3.0390732288360596, -0.6747525334358215, -2.4338583946228027, 0.5973352789878845, 1.0412092208862305, -2.9303464889526367], [-0.35886093974113464, -1.0711790323257446, -0.8018397092819214, 2.2472195625305176, -0.2547323405742645, -1.2068699598312378, -0.662876307964325, -0.24305079877376556, 0.45404982566833496, 0.2296542227268219, 0.7858901023864746, 0.7955016493797302, -1.1199491024017334, 2.034775972366333, 0.7971591353416443, 1.9897938966751099, -1.4930272102355957, 1.7808598279953003, -0.3249305784702301, 1.2736724615097046, 0.252833753824234, 1.804606556892395, 0.7773964405059814, 0.35463473200798035], [0.5755221247673035, 0.48037460446357727, -0.36268678307533264, 1.4692699909210205, -0.6136266589164734, -0.10416698455810547, 2.9237167835235596, 0.9100657105445862, -3.677903175354004, 1.0722336769104004, 1.1470963954925537, 2.476576566696167, -0.29501524567604065, 1.5706243515014648, 1.1119688749313354, -0.31394898891448975, 0.8883726000785828, -1.0701828002929688, 3.608590841293335, -0.704870879650116, -0.9470258951187134, 0.3351796865463257, 1.484681487083435, -3.5001721382141113], [3.3485348224639893, 0.96633380651474, 4.0846099853515625, 3.0586042404174805, 5.314487934112549, 1.211072564125061, -2.5569372177124023, -3.6462795734405518, -1.281952142715454, 2.2995665073394775, 0.3908262550830841, -1.3308604955673218, 1.5395900011062622, 3.0327868461608887, 0.9207255244255066, 0.7713736891746521, 1.7159342765808105, 1.022119402885437, -2.487516403198242, 1.0456103086471558, -1.3899167776107788, -4.017914295196533, 2.081852674484253, -2.826282024383545], [1.097206711769104, -0.4557645320892334, 1.1800594329833984, 1.3580716848373413, 1.267151951789856, -1.1361018419265747, 1.3419150114059448, -3.28023624420166, 1.6124194860458374, -0.16716918349266052, 1.643646001815796, 0.6211049556732178, 1.0675534009933472, 0.563510537147522, -2.268536329269409, -0.9692060351371765, 1.270824909210205, 0.9109257459640503, 1.8781565427780151, -1.2009247541427612, 1.522371768951416, 0.5015612840652466, -1.194045066833496, 1.504223108291626], [1.3558467626571655, -0.3236102759838104, 1.8180052042007446, 0.5962472558021545, 1.2633033990859985, -0.004050882067531347, 1.0542012453079224, -0.6200582981109619, 1.309576392173767, -0.6445831656455994, 1.821542739868164, 1.6528500318527222, 1.2039070129394531, -1.1384799480438232, -0.6668269634246826, -0.7235439419746399, -0.8642497062683105, -1.471147894859314, 0.9304599761962891, -0.9011414647102356, 2.3477699756622314, 2.2899656295776367, -1.1537950038909912, 1.129063606262207], [4.134111404418945, 1.0200783014297485, 1.770235300064087, 0.38284048438072205, -3.8822133541107178, 0.8889518976211548, 0.11506128311157227, 1.0146852731704712, 0.6673757433891296, 1.1524369716644287, -0.831250011920929, -0.5163359642028809, -4.0955634117126465, 1.202041506767273, 1.2008339166641235, 0.07305790483951569, 1.5476871728897095, -0.19491764903068542, -0.5095011591911316, -2.5963237285614014, -0.10004328936338425, -1.0751537084579468, 3.229844331741333, -0.47923287749290466], [-1.250232458114624, 0.5905649065971375, -0.08256929367780685, 0.9054294228553772, 0.27175965905189514, 2.6444907188415527, 1.0862230062484741, 1.7406926155090332, 1.0049235820770264, 0.5723413228988647, 0.45481130480766296, 1.066864252090454, 0.9283227324485779, 0.2744450271129608, -0.3252626657485962, -1.4832520484924316, -0.45937055349349976, 0.9746733903884888, 0.5272085666656494, 1.7287968397140503, 0.40107712149620056, 0.4439826011657715, 1.5116416215896606, 1.5723758935928345], [0.9248763918876648, 1.447110891342163, 1.2569127082824707, 0.13202568888664246, 1.23287034034729, -0.09431985020637512, -0.20055058598518372, 0.9811994433403015, 1.1800695657730103, -0.6481343507766724, 0.6477194428443909, 1.4359490871429443, 0.4489688277244568, -2.0626895427703857, 3.5341994762420654, 0.38320192694664, 0.11111105978488922, -1.7785009145736694, 0.3654748201370239, 0.8717004656791687, 0.7262043952941895, 1.6146215200424194, 0.24619705975055695, 1.2802846431732178], [1.0777146816253662, 0.6887889504432678, 0.9763043522834778, 1.0912832021713257, 1.6754050254821777, 2.861457586288452, 0.9644241333007812, 0.5982322096824646, 1.041653037071228, 0.2874344289302826, 1.1167256832122803, 0.33687469363212585, -0.4786717891693115, -0.36680084466934204, 0.19943539798259735, -1.200127124786377, -0.5142126083374023, 0.7692820429801941, 0.6361661553382874, 1.5032871961593628, 1.4838706254959106, 1.1542298793792725, 0.17455990612506866, 0.9212511777877808], [4.860254287719727, -0.25654035806655884, 2.73272442817688, -0.4675641357898712, -6.920983791351318, -0.36660873889923096, 1.1785703897476196, -1.0171481370925903, 2.4884424209594727, 2.0805416107177734, -1.0568853616714478, -0.25894537568092346, -3.7637181282043457, 2.176224708557129, 0.9384779930114746, 1.6383451223373413, -0.2375909835100174, 1.563838243484497, 1.846806287765503, 1.3428863286972046, -1.435538411140442, -2.1141557693481445, -0.3165300488471985, 1.7748430967330933], [2.769883871078491, 1.8943456411361694, 0.3640352189540863, 1.785844326019287, 0.7344745397567749, 0.39368563890457153, -2.3875362873077393, 0.8995029330253601, 1.6547513008117676, 1.3176071643829346, -0.9724606871604919, 2.93916654586792, 2.3889293670654297, -1.1804139614105225, 4.386131763458252, 0.7749289274215698, 0.19975459575653076, -2.9396250247955322, -0.43144774436950684, 2.340695381164551, 1.5396018028259277, 1.726706624031067, 2.3074934482574463, 1.5196326971054077], [1.7053111791610718, 0.47502008080482483, 1.0501796007156372, -2.0408339500427246, -0.13104568421840668, 0.33137980103492737, 0.04775332286953926, 2.4728024005889893, -1.4185632467269897, 1.384668231010437, -0.7048049569129944, -1.0509675741195679, 0.5553595423698425, 0.8570550084114075, 1.1651074886322021, 0.7824841737747192, -1.3527337312698364, -0.7139086127281189, -1.1417115926742554, 0.9422053098678589, -0.7971199750900269, -0.2167477160692215, 1.5796117782592773, 0.16019374132156372]]",
// "weightJS2":
// "[[1.9749627113342285, 0.2404414713382721, 4.499286651611328, -1.0144044160842896, 2.829622983932495, -0.057477254420518875, -3.6028494834899902, -0.07592786103487015, -2.284479856491089], [2.9142587184906006, 0.14349043369293213, 0.034647803753614426, 1.630078911781311, 0.21582122147083282, 1.035940170288086, 1.7996511459350586, -0.12669681012630463, 0.29656586050987244], [0.07991915196180344, -3.312174081802368, 2.0938096046447754, -1.237191915512085, 3.0206546783447266, -0.018381912261247635, 4.422645568847656, -4.032643795013428, 0.5288013815879822], [-0.3284018635749817, 2.989541530609131, -0.6642281413078308, 0.5154777765274048, 1.8245141506195068, 0.9808709025382996, -0.8129456043243408, 0.3030719757080078, -1.020087480545044], [0.016836216673254967, 1.6461126804351807, -4.328018665313721, -0.021215196698904037, 4.4825334548950195, -0.7261971831321716, -1.5536736249923706, 0.07121726870536804, 0.6052526831626892], [-0.5535260438919067, -0.7827446460723877, -0.8992803692817688, -0.24288810789585114, -0.3411737382411957, -0.6795476078987122, -0.8662106394767761, -0.9232723116874695, 11.626473426818848], [-2.5547831058502197, -1.029831886291504, 0.7786807417869568, 1.6619913578033447, -2.1873247623443604, 2.495579719543457, -1.6966722011566162, 4.159885406494141, -0.21722158789634705], [3.440404176712036, -0.9836574792861938, 0.17408487200737, 0.6699033379554749, -2.6936252117156982, 0.6502456665039062, 0.9803906679153442, 0.1889471560716629, 2.7631726264953613], [0.7359793186187744, -2.7816343307495117, 2.2713539600372314, 1.0174250602722168, -1.2494703531265259, -5.437539577484131, -0.5791329741477966, 1.608538031578064, 3.1371114253997803], [1.364742398262024, 0.9572967886924744, 1.9356130361557007, 0.8062270879745483, 1.4080042839050293, 1.1558339595794678, 1.9050817489624023, 1.6431550979614258, 1.0936533212661743], [-1.6878529787063599, -0.20728130638599396, -0.5994408130645752, -1.8281294107437134, 0.24465569853782654, 1.4410701990127563, -2.161224603652954, -0.4612058699131012, 2.589486837387085], [2.5645225048065186, -2.414802074432373, -0.5029224753379822, -2.476569652557373, -0.8130285739898682, 4.222813606262207, -3.7621500492095947, 1.437982439994812, -0.41775432229042053], [2.431997537612915, -3.6574742794036865, -3.21728777885437, 3.985774040222168, 1.010752558708191, 0.5697790384292603, 1.6467233896255493, 0.7546154856681824, -1.334580898284912], [-2.827427625656128, 1.7032489776611328, 2.11814284324646, 0.30391034483909607, 2.579265832901001, 0.23728306591510773, 0.9366695880889893, 2.0961742401123047, 0.4443163573741913], [6.536571979522705, 0.3252210021018982, 0.47008466720581055, 0.3100663721561432, -0.746806800365448, 0.5565483570098877, 0.07242288440465927, -0.04018740355968475, 1.5937074422836304], [2.4231934547424316, 1.1276671886444092, 1.4375793933868408, 0.6470419764518738, 1.408554196357727, 0.9919240474700928, 1.220597267150879, 0.9893061518669128, 0.29316332936286926], [0.6666469573974609, -0.6954585909843445, 0.5175284743309021, 3.3031747341156006, 2.2068967819213867, 1.4418079853057861, 1.4853301048278809, 0.06092767417430878, -0.5447710156440735], [-3.4399025440216064, 0.2934260964393616, 1.5721722841262817, 0.8964863419532776, 1.0936353206634521, 0.4710237979888916, 1.1171822547912598, 1.1114387512207031, 2.749636650085449], [-1.2879736423492432, -0.8956615328788757, 1.2662760019302368, 1.830581545829773, -1.7124319076538086, 2.5808987617492676, 1.9343351125717163, -4.504626274108887, -0.8327578902244568], [3.2626099586486816, 1.2724570035934448, 1.443620204925537, -0.3940924406051636, 0.844620943069458, 0.6732372641563416, 0.3383709490299225, 1.6434345245361328, 2.399984836578369], [-0.4097330868244171, -0.4845009744167328, -1.524335503578186, -2.7316455841064453, -1.4284635782241821, -1.596526026725769, 4.845731258392334, 4.008439540863037, -1.7798140048980713], [-0.27366065979003906, 3.3561480045318604, -0.7407917976379395, -2.1552276611328125, -2.4002108573913574, 0.45311087369918823, 2.201896905899048, -2.589961051940918, 0.7544904351234436], [1.6875838041305542, 1.6762372255325317, 0.4864174723625183, 1.1023706197738647, -0.4291389286518097, 1.6483114957809448, 0.723427414894104, 1.231937289237976, 2.2384915351867676], [-0.016140121966600418, 2.6373164653778076, 1.066977858543396, 3.566697835922241, -1.8497729301452637, -2.677297592163086, -2.330751895904541, -1.3379294872283936, -0.9855337142944336]]"
// }

// let observArr:number[] = [0,0,0,0,0,0,0,0,0,0,0]

// const bias0 = JSON.parse(coefJS['biasJS0'])
// const weight0 = JSON.parse(coefJS['weightJS0'])
// const bias1 = JSON.parse(coefJS['biasJS1'])
// const weight1 = JSON.parse(coefJS['weightJS1'])
// const bias2 = JSON.parse(coefJS['biasJS2'])
// const weight2 = JSON.parse(coefJS['weightJS2'])
// console.log(bias0[0])
// console.log(weight0[0])



// window.onload = () => {
//     return
//     cf = new CrestField(document)
//     cf.init()
//     let gf = document.getElementById("crestField") as HTMLTableElement
//         //this.cardSetDiv = document.getElementById("cardSet") as HTMLDivElement
//         gf.addEventListener("click", (ev) =>{ cf.handleClick(ev); })
//     return
//     let field: HTMLTableElement= document.getElementById("gameField") as HTMLTableElement
//     fillCardSetSq()
//     field.addEventListener("click", (ev) =>{ handleClickSq(ev); })
//     let cellsCol = field.rows[0].cells
// }

// class CrestField{
//     cardSet:number[]
//     cardSetDiv: HTMLDivElement
//     gameField:number[] 
//     fieldView: HTMLElement[]

//     nameToInt = {
//         "c0" :0 ,
//         "c1" :1 ,
//         "c2" :2 ,
//         "c3" :3 ,
//         "c4" :4 ,
//         "c5" :5 ,
//         "c6" :6 ,
//         "c7" :7 ,
//         "c8" :8 ,
//     }

//     constructor(doc:HTMLDocument){
//         const body:HTMLCollection = doc.getElementsByTagName("body")
//         body[0].innerHTML = `
//             <table id = "crestField">
//                 <tr><td class="empty"></td><td id="c0"></td><td id="c1"></td><td class="empty"></td></tr>
//                 <tr><td id="c2"></td><td id="c3"></td><td id="c4"></td><td id="c5"></td></tr>
//                 <tr><td id="c6"></td><td id="c7"></td><td id="c8"></td><td id="c9"></td></tr>
//                 <tr><td class="empty"></td><td id="c10"></td><td id="c11"></td><td class="empty"></td></tr>
//             </table>
//             <div id = "cardSet"></div>
//         `
//         let gf = document.getElementById("crestField") as HTMLTableElement
//         this.cardSetDiv = document.getElementById("cardSet") as HTMLDivElement
//         gf.addEventListener("click", (ev) =>{ cf.handleClick(ev); })
//     }

//     init() {
//         for (let i = 0; i < 9; i++) {
//             this.cardSet.push(1)
//             this.cardSet.push(2)
//             this.cardSet.push(3)
//             this.cardSet.push(4)
//         }

//         this.cardSetDiv.innerHTML = cardSet.toString()
//     }

//     handleClick(ev){
//         console.log("clicked")
//     }
// }


